export const PRODUCTS = [
    {
        "url": "https://www.eaton.com/mx/es-mx/catalog/medium-voltage-power-distribution-control-systems/loadbreak-connectors.html",
        "target": "_self",
        "goToProductLabel": "Ir a Conectores de operación con carga",
        "desktopRendition": "https://www.eaton.com/mdmfiles/PDM31110999/ES-PSD-LOADBREAKCONNECTORS_FM/500x500_72dpi",
        "mobileRendition": "https://www.eaton.com/mdmfiles/PDM31110999/ES-PSD-LOADBREAKCONNECTORS_FM/500x500_72dpi",
        "discontinued": false,
        "discontinuedLabel": "Descontinuado",
        "tobediscontinued": false,
        "tobediscontinuedLabel": "Será descontinuado",
        "newBadgeVisible": false,
        "newBadgeLabel": "Nuevo",
        "showSubCategory": false,
        "subCategoryName": "",
        "showProductDescription": true,
        "productGridDescription": "",
        "productName": "Conectores de operación con carga",
        "desc": "Los conectores codo de operación con carga y los accesorios de la serie Cooper Power de Eaton de 200 A, 15, 25 y 35 kV, y la tecnología Cleer de operación con carga de 600 A, 15 y 25 kV conectan el cable subterráneo a los transformadores, a los gabinetes seccionadores y a las uniones. Son ideales para terminaciones enchufables sumergibles, completamente apantalladas y aisladas. Estos conectores están moldeados con aislamiento EPDM curado con peróxido de alta calidad para un rendimiento confiable en el campo.",
        "models": [
            {
                "attributeGroups": [
                    {
                        "attributeList": []
                    }
                ],
                "attributeTables": [],
                "skuPageUrl": "https://www.eaton.com/mx/es-mx/skuPage.2632279A0002.html",
                "skuPageSpecificationUrl": "https://www.eaton.com/mx/es-mx/skuPage.2632279A0002.html#tab-1",
                "skuPageResourcesUrl": "https://www.eaton.com/mx/es-mx/skuPage.2632279A0002.html#tab-2",
                "desktopRendition": "",
                "mobileRendition": "",
                "catalogNumber": "2632279A0002",
                "modelCode": "",
                "price": "",
                "longDescription": "Eaton Cooper Power series loadbreak elbow, LV Bushing 1-3/8 X 5 Thd Zytel",
                "specificationLabel": "Especificaciones",
                "resourceLabel": "Recursos",
                "familyName": "Eaton Cooper Power series loadbreak elbow",
                "compareLabel": "Compare",
                "marketingDescription": "Eaton’s Cooper Power series 200 A 15, 25 and 35 kV loadbreak elbow connectors and accessories and 600 A 15 and 25 kV Cleer loadbreak technology connect underground cable to transformers, sectionalizing cabinets and junctions. They are ideal for submersible, fully-shielded and insulated plug-in terminations. These connectors are molded using high-quality, peroxide-cured EPDM insulation for reliable field performance",
                "serialFlag": false,
                "serialAuthFlag": false,
                "replacements": [],
                "crossSell": [],
                "upSell": [],
                "images": [],
                "resources": [],
                "status": "Active",
                "label": "2632279A0002",
                "forPriceSpider": false,
                "forPowerReviews": false,
                "doNotShowProductImages": false
            },
            {
                "attributeGroups": [
                    {
                        "attributeList": []
                    }
                ],
                "attributeTables": [],
                "skuPageUrl": "https://www.eaton.com/mx/es-mx/skuPage.FEADPT.html",
                "skuPageSpecificationUrl": "https://www.eaton.com/mx/es-mx/skuPage.FEADPT.html#tab-1",
                "skuPageResourcesUrl": "https://www.eaton.com/mx/es-mx/skuPage.FEADPT.html#tab-2",
                "desktopRendition": "",
                "mobileRendition": "",
                "catalogNumber": "FEADPT",
                "modelCode": "",
                "price": "",
                "longDescription": "Eaton Cooper Power series loadbreak elbow, Adapter, FE Fuse, 25 kV, 200A, 60 Hz, 25 Kilovolts,",
                "specificationLabel": "Especificaciones",
                "resourceLabel": "Recursos",
                "familyName": "Eaton Cooper Power series loadbreak elbow",
                "compareLabel": "Compare",
                "marketingDescription": "Eaton’s Cooper Power series 200 A 15, 25 and 35 kV loadbreak elbow connectors and accessories and 600 A 15 and 25 kV Cleer loadbreak technology connect underground cable to transformers, sectionalizing cabinets and junctions. They are ideal for submersible, fully-shielded and insulated plug-in terminations. These connectors are molded using high-quality, peroxide-cured EPDM insulation for reliable field performance",
                "serialFlag": false,
                "serialAuthFlag": false,
                "replacements": [],
                "crossSell": [],
                "upSell": [],
                "images": [],
                "resources": [],
                "status": "Active",
                "label": "FEADPT",
                "forPriceSpider": false,
                "forPowerReviews": false,
                "doNotShowProductImages": false
            },
            {
                "attributeGroups": [
                    {
                        "attributeList": []
                    }
                ],
                "attributeTables": [],
                "skuPageUrl": "https://www.eaton.com/mx/es-mx/skuPage.LE215AB04T.html",
                "skuPageSpecificationUrl": "https://www.eaton.com/mx/es-mx/skuPage.LE215AB04T.html#tab-1",
                "skuPageResourcesUrl": "https://www.eaton.com/mx/es-mx/skuPage.LE215AB04T.html#tab-2",
                "desktopRendition": "https://www.eaton.com/mdmfiles/PDM30075038/LE215AB06TX_R/110x110_96dpi",
                "mobileRendition": "https://www.eaton.com/mdmfiles/PDM30075038/LE215AB06TX_R/500x500_72dpi",
                "catalogNumber": "LE215AB04T",
                "modelCode": "",
                "price": "",
                "longDescription": "Eaton Cooper Power series loadbreak elbow, 200 A, Std V:15 kV, Max phase-to-ground:8.3 kV, AC 1 min:34 kV, DC 15 min:34 kV, Impulse:95 kV, Max corona:11 kV, Test:Yes, 0.61 inch, 0.97 inch, 15.5 mm, 24.6 mm, #2 AWG, #1 AWG, 20 pack",
                "specificationLabel": "Especificaciones",
                "resourceLabel": "Recursos",
                "familyName": "Eaton Cooper Power series loadbreak elbow",
                "compareLabel": "Compare",
                "marketingDescription": "Eaton’s Cooper Power series 200 A 15, 25 and 35 kV loadbreak elbow connectors and accessories and 600 A 15 and 25 kV Cleer loadbreak technology connect underground cable to transformers, sectionalizing cabinets and junctions. They are ideal for submersible, fully-shielded and insulated plug-in terminations. These connectors are molded using high-quality, peroxide-cured EPDM insulation for reliable field performance",
                "serialFlag": false,
                "serialAuthFlag": false,
                "replacements": [],
                "crossSell": [],
                "upSell": [],
                "images": [],
                "resources": [],
                "status": "Active",
                "label": "LE215AB04T",
                "forPriceSpider": false,
                "forPowerReviews": false,
                "doNotShowProductImages": false
            },
            {
                "attributeGroups": [
                    {
                        "attributeList": []
                    }
                ],
                "attributeTables": [],
                "skuPageUrl": "https://www.eaton.com/mx/es-mx/skuPage.LE215AB06T.html",
                "skuPageSpecificationUrl": "https://www.eaton.com/mx/es-mx/skuPage.LE215AB06T.html#tab-1",
                "skuPageResourcesUrl": "https://www.eaton.com/mx/es-mx/skuPage.LE215AB06T.html#tab-2",
                "desktopRendition": "https://www.eaton.com/mdmfiles/PDM30075038/LE215AB06TX_R/110x110_96dpi",
                "mobileRendition": "https://www.eaton.com/mdmfiles/PDM30075038/LE215AB06TX_R/500x500_72dpi",
                "catalogNumber": "LE215AB06T",
                "modelCode": "",
                "price": "",
                "longDescription": "Eaton Cooper Power series loadbreak elbow, 200 A, Std V:15 kV, Max phase-to-ground:8.3 kV, AC 1 min:34 kV, DC 15 min:34 kV, Impulse:95 kV, Max corona:11 kV, Test:Yes, 0.61 inch, 0.97 inch, 15.5 mm, 24.6 mm, 1/0 AWG, 2/0 AWG, 20 pack",
                "specificationLabel": "Especificaciones",
                "resourceLabel": "Recursos",
                "familyName": "Eaton Cooper Power series loadbreak elbow",
                "compareLabel": "Compare",
                "marketingDescription": "Eaton’s Cooper Power series 200 A 15, 25 and 35 kV loadbreak elbow connectors and accessories and 600 A 15 and 25 kV Cleer loadbreak technology connect underground cable to transformers, sectionalizing cabinets and junctions. They are ideal for submersible, fully-shielded and insulated plug-in terminations. These connectors are molded using high-quality, peroxide-cured EPDM insulation for reliable field performance",
                "serialFlag": false,
                "serialAuthFlag": false,
                "replacements": [],
                "crossSell": [],
                "upSell": [],
                "images": [],
                "resources": [],
                "status": "Active",
                "label": "LE215AB06T",
                "forPriceSpider": false,
                "forPowerReviews": false,
                "doNotShowProductImages": false
            },
            {
                "attributeGroups": [
                    {
                        "attributeList": []
                    }
                ],
                "attributeTables": [],
                "skuPageUrl": "https://www.eaton.com/mx/es-mx/skuPage.LE215AB07T.html",
                "skuPageSpecificationUrl": "https://www.eaton.com/mx/es-mx/skuPage.LE215AB07T.html#tab-1",
                "skuPageResourcesUrl": "https://www.eaton.com/mx/es-mx/skuPage.LE215AB07T.html#tab-2",
                "desktopRendition": "https://www.eaton.com/mdmfiles/PDM30075038/LE215AB06TX_R/110x110_96dpi",
                "mobileRendition": "https://www.eaton.com/mdmfiles/PDM30075038/LE215AB06TX_R/500x500_72dpi",
                "catalogNumber": "LE215AB07T",
                "modelCode": "",
                "price": "",
                "longDescription": "Eaton Cooper Power series loadbreak elbow, 200 A, Std V:15 kV, Max phase-to-ground:8.3 kV, AC 1 min:34 kV, DC 15 min:34 kV, Impulse:95 kV, Max corona:11 kV, Test:Yes, 0.61 inch, 0.97 inch, 15.5 mm, 24.6 mm, 2/0 AWG, 3/0 AWG, 20 pack",
                "specificationLabel": "Especificaciones",
                "resourceLabel": "Recursos",
                "familyName": "Eaton Cooper Power series loadbreak elbow",
                "compareLabel": "Compare",
                "marketingDescription": "Eaton’s Cooper Power series 200 A 15, 25 and 35 kV loadbreak elbow connectors and accessories and 600 A 15 and 25 kV Cleer loadbreak technology connect underground cable to transformers, sectionalizing cabinets and junctions. They are ideal for submersible, fully-shielded and insulated plug-in terminations. These connectors are molded using high-quality, peroxide-cured EPDM insulation for reliable field performance",
                "serialFlag": false,
                "serialAuthFlag": false,
                "replacements": [],
                "crossSell": [],
                "upSell": [],
                "images": [],
                "resources": [],
                "status": "Active",
                "label": "LE215AB07T",
                "forPriceSpider": false,
                "forPowerReviews": false,
                "doNotShowProductImages": false
            },
            {
                "attributeGroups": [
                    {
                        "attributeList": []
                    }
                ],
                "attributeTables": [],
                "skuPageUrl": "https://www.eaton.com/mx/es-mx/skuPage.LE215AB08T.html",
                "skuPageSpecificationUrl": "https://www.eaton.com/mx/es-mx/skuPage.LE215AB08T.html#tab-1",
                "skuPageResourcesUrl": "https://www.eaton.com/mx/es-mx/skuPage.LE215AB08T.html#tab-2",
                "desktopRendition": "https://www.eaton.com/mdmfiles/PDM30075038/LE215AB06TX_R/110x110_96dpi",
                "mobileRendition": "https://www.eaton.com/mdmfiles/PDM30075038/LE215AB06TX_R/500x500_72dpi",
                "catalogNumber": "LE215AB08T",
                "modelCode": "",
                "price": "",
                "longDescription": "Eaton Cooper Power series loadbreak elbow, 200 A, Std V:15 kV, Max phase-to-ground:8.3 kV, AC 1 min:34 kV, DC 15 min:34 kV, Impulse:95 kV, Max corona:11 kV, Test:Yes, 0.61 inch, 0.97 inch, 15.5 mm, 24.6 mm, 3/0 AWG, 4/0 AWG, 20 pack",
                "specificationLabel": "Especificaciones",
                "resourceLabel": "Recursos",
                "familyName": "Eaton Cooper Power series loadbreak elbow",
                "compareLabel": "Compare",
                "marketingDescription": "Eaton’s Cooper Power series 200 A 15, 25 and 35 kV loadbreak elbow connectors and accessories and 600 A 15 and 25 kV Cleer loadbreak technology connect underground cable to transformers, sectionalizing cabinets and junctions. They are ideal for submersible, fully-shielded and insulated plug-in terminations. These connectors are molded using high-quality, peroxide-cured EPDM insulation for reliable field performance",
                "serialFlag": false,
                "serialAuthFlag": false,
                "replacements": [],
                "crossSell": [],
                "upSell": [],
                "images": [],
                "resources": [],
                "status": "Active",
                "label": "LE215AB08T",
                "forPriceSpider": false,
                "forPowerReviews": false,
                "doNotShowProductImages": false
            },
            {
                "attributeGroups": [
                    {
                        "attributeList": []
                    }
                ],
                "attributeTables": [],
                "skuPageUrl": "https://www.eaton.com/mx/es-mx/skuPage.LE215AB09.html",
                "skuPageSpecificationUrl": "https://www.eaton.com/mx/es-mx/skuPage.LE215AB09.html#tab-1",
                "skuPageResourcesUrl": "https://www.eaton.com/mx/es-mx/skuPage.LE215AB09.html#tab-2",
                "desktopRendition": "https://www.eaton.com/mdmfiles/PDM30075036/LE215AB06TX_C/110x110_96dpi",
                "mobileRendition": "https://www.eaton.com/mdmfiles/PDM30075036/LE215AB06TX_C/500x500_72dpi",
                "catalogNumber": "LE215AB09",
                "modelCode": "",
                "price": "",
                "longDescription": "Eaton Cooper Power series loadbreak elbow,15KV,200A,LB,.61-.97,4/0-250",
                "specificationLabel": "Especificaciones",
                "resourceLabel": "Recursos",
                "familyName": "Eaton Cooper Power series loadbreak elbow",
                "compareLabel": "Compare",
                "marketingDescription": "Eaton’s Cooper Power series 200 A 15, 25 and 35 kV loadbreak elbow connectors and accessories and 600 A 15 and 25 kV Cleer loadbreak technology connect underground cable to transformers, sectionalizing cabinets and junctions. They are ideal for submersible, fully-shielded and insulated plug-in terminations. These connectors are molded using high-quality, peroxide-cured EPDM insulation for reliable field performance",
                "serialFlag": false,
                "serialAuthFlag": false,
                "replacements": [],
                "crossSell": [],
                "upSell": [],
                "images": [],
                "resources": [],
                "status": "Active",
                "label": "LE215AB09",
                "forPriceSpider": false,
                "forPowerReviews": false,
                "doNotShowProductImages": false
            },
            {
                "attributeGroups": [
                    {
                        "attributeList": []
                    }
                ],
                "attributeTables": [],
                "skuPageUrl": "https://www.eaton.com/mx/es-mx/skuPage.LE215AB09T.html",
                "skuPageSpecificationUrl": "https://www.eaton.com/mx/es-mx/skuPage.LE215AB09T.html#tab-1",
                "skuPageResourcesUrl": "https://www.eaton.com/mx/es-mx/skuPage.LE215AB09T.html#tab-2",
                "desktopRendition": "https://www.eaton.com/mdmfiles/PDM30075038/LE215AB06TX_R/110x110_96dpi",
                "mobileRendition": "https://www.eaton.com/mdmfiles/PDM30075038/LE215AB06TX_R/500x500_72dpi",
                "catalogNumber": "LE215AB09T",
                "modelCode": "",
                "price": "",
                "longDescription": "Eaton Cooper Power series loadbreak elbow, 200 A, Std V:15 kV, Max phase-to-ground:8.3 kV, AC 1 min:34 kV, DC 15 min:34 kV, Impulse:95 kV, Max corona:11 kV, Test:Yes, 0.61 inch, 0.97 inch, 15.5 mm, 24.6 mm, 4/0 AWG, 250 AWG, 20 pack",
                "specificationLabel": "Especificaciones",
                "resourceLabel": "Recursos",
                "familyName": "Eaton Cooper Power series loadbreak elbow",
                "compareLabel": "Compare",
                "marketingDescription": "Eaton’s Cooper Power series 200 A 15, 25 and 35 kV loadbreak elbow connectors and accessories and 600 A 15 and 25 kV Cleer loadbreak technology connect underground cable to transformers, sectionalizing cabinets and junctions. They are ideal for submersible, fully-shielded and insulated plug-in terminations. These connectors are molded using high-quality, peroxide-cured EPDM insulation for reliable field performance",
                "serialFlag": false,
                "serialAuthFlag": false,
                "replacements": [],
                "crossSell": [],
                "upSell": [],
                "images": [],
                "resources": [],
                "status": "Active",
                "label": "LE215AB09T",
                "forPriceSpider": false,
                "forPowerReviews": false,
                "doNotShowProductImages": false
            },
            {
                "attributeGroups": [
                    {
                        "attributeList": []
                    }
                ],
                "attributeTables": [],
                "skuPageUrl": "https://www.eaton.com/mx/es-mx/skuPage.LE215CC10.html",
                "skuPageSpecificationUrl": "https://www.eaton.com/mx/es-mx/skuPage.LE215CC10.html#tab-1",
                "skuPageResourcesUrl": "https://www.eaton.com/mx/es-mx/skuPage.LE215CC10.html#tab-2",
                "desktopRendition": "https://www.eaton.com/mdmfiles/PDM30075036/LE215AB06TX_C/110x110_96dpi",
                "mobileRendition": "https://www.eaton.com/mdmfiles/PDM30075036/LE215AB06TX_C/500x500_72dpi",
                "catalogNumber": "LE215CC10",
                "modelCode": "",
                "price": "",
                "longDescription": "Eaton Cooper Power series loadbreak elbow,15KV,200A,LB,.75-1.08,250-300",
                "specificationLabel": "Especificaciones",
                "resourceLabel": "Recursos",
                "familyName": "Eaton Cooper Power series loadbreak elbow",
                "compareLabel": "Compare",
                "marketingDescription": "Eaton’s Cooper Power series 200 A 15, 25 and 35 kV loadbreak elbow connectors and accessories and 600 A 15 and 25 kV Cleer loadbreak technology connect underground cable to transformers, sectionalizing cabinets and junctions. They are ideal for submersible, fully-shielded and insulated plug-in terminations. These connectors are molded using high-quality, peroxide-cured EPDM insulation for reliable field performance",
                "serialFlag": false,
                "serialAuthFlag": false,
                "replacements": [],
                "crossSell": [],
                "upSell": [],
                "images": [],
                "resources": [],
                "status": "Active",
                "label": "LE215CC10",
                "forPriceSpider": false,
                "forPowerReviews": false,
                "doNotShowProductImages": false
            },
            {
                "attributeGroups": [
                    {
                        "attributeList": []
                    }
                ],
                "attributeTables": [],
                "skuPageUrl": "https://www.eaton.com/mx/es-mx/skuPage.LE215CC10T.html",
                "skuPageSpecificationUrl": "https://www.eaton.com/mx/es-mx/skuPage.LE215CC10T.html#tab-1",
                "skuPageResourcesUrl": "https://www.eaton.com/mx/es-mx/skuPage.LE215CC10T.html#tab-2",
                "desktopRendition": "https://www.eaton.com/mdmfiles/PDM30075038/LE215AB06TX_R/110x110_96dpi",
                "mobileRendition": "https://www.eaton.com/mdmfiles/PDM30075038/LE215AB06TX_R/500x500_72dpi",
                "catalogNumber": "LE215CC10T",
                "modelCode": "",
                "price": "",
                "longDescription": "Eaton Cooper Power series loadbreak elbow, 200 A, Std V:15 kV, Max phase-to-ground:8.3 kV, AC 1 min:34 kV, DC 15 min:34 kV, Impulse:95 kV, Max corona:11 kV, Test:Yes, 0.75 inch, 1.08 inch, 19.1 mm, 27.4 mm, 250 AWG, 300 AWG, 20 pack",
                "specificationLabel": "Especificaciones",
                "resourceLabel": "Recursos",
                "familyName": "Eaton Cooper Power series loadbreak elbow",
                "compareLabel": "Compare",
                "marketingDescription": "Eaton’s Cooper Power series 200 A 15, 25 and 35 kV loadbreak elbow connectors and accessories and 600 A 15 and 25 kV Cleer loadbreak technology connect underground cable to transformers, sectionalizing cabinets and junctions. They are ideal for submersible, fully-shielded and insulated plug-in terminations. These connectors are molded using high-quality, peroxide-cured EPDM insulation for reliable field performance",
                "serialFlag": false,
                "serialAuthFlag": false,
                "replacements": [],
                "crossSell": [],
                "upSell": [],
                "images": [],
                "resources": [],
                "status": "Active",
                "label": "LE215CC10T",
                "forPriceSpider": false,
                "forPowerReviews": false,
                "doNotShowProductImages": false
            },
            {
                "attributeGroups": [
                    {
                        "attributeList": []
                    }
                ],
                "attributeTables": [],
                "skuPageUrl": "https://www.eaton.com/mx/es-mx/skuPage.LE225CC06T.html",
                "skuPageSpecificationUrl": "https://www.eaton.com/mx/es-mx/skuPage.LE225CC06T.html#tab-1",
                "skuPageResourcesUrl": "https://www.eaton.com/mx/es-mx/skuPage.LE225CC06T.html#tab-2",
                "desktopRendition": "https://www.eaton.com/mdmfiles/PDM30075041/LE225CC06TX_R/110x110_96dpi",
                "mobileRendition": "https://www.eaton.com/mdmfiles/PDM30075041/LE225CC06TX_R/500x500_72dpi",
                "catalogNumber": "LE225CC06T",
                "modelCode": "",
                "price": "",
                "longDescription": "Eaton Cooper Power series loadbreak elbow, 200 A, Std V:25 kV, Max phase-to-ground:15.2 kV, AC 1 min:40 kV, DC 15 min:78 kV, Impulse:125 kV, Max corona:19 kV, Test:Yes, 0.75 inch, 1.08 inch, 19.1 mm, 27.4 mm, 1/0 AWG, 2/0 AWG, 20 pack",
                "specificationLabel": "Especificaciones",
                "resourceLabel": "Recursos",
                "familyName": "Eaton Cooper Power series loadbreak elbow",
                "compareLabel": "Compare",
                "marketingDescription": "Eaton’s Cooper Power series 200 A 15, 25 and 35 kV loadbreak elbow connectors and accessories and 600 A 15 and 25 kV Cleer loadbreak technology connect underground cable to transformers, sectionalizing cabinets and junctions. They are ideal for submersible, fully-shielded and insulated plug-in terminations. These connectors are molded using high-quality, peroxide-cured EPDM insulation for reliable field performance",
                "serialFlag": false,
                "serialAuthFlag": false,
                "replacements": [],
                "crossSell": [],
                "upSell": [],
                "images": [],
                "resources": [],
                "status": "Active",
                "label": "LE225CC06T",
                "forPriceSpider": false,
                "forPowerReviews": false,
                "doNotShowProductImages": false
            },
            {
                "attributeGroups": [
                    {
                        "attributeList": []
                    }
                ],
                "attributeTables": [],
                "skuPageUrl": "https://www.eaton.com/mx/es-mx/skuPage.LE225CC08T.html",
                "skuPageSpecificationUrl": "https://www.eaton.com/mx/es-mx/skuPage.LE225CC08T.html#tab-1",
                "skuPageResourcesUrl": "https://www.eaton.com/mx/es-mx/skuPage.LE225CC08T.html#tab-2",
                "desktopRendition": "https://www.eaton.com/mdmfiles/PDM30075041/LE225CC06TX_R/110x110_96dpi",
                "mobileRendition": "https://www.eaton.com/mdmfiles/PDM30075041/LE225CC06TX_R/500x500_72dpi",
                "catalogNumber": "LE225CC08T",
                "modelCode": "",
                "price": "",
                "longDescription": "Eaton Cooper Power series loadbreak elbow, 200 A, Std V:25 kV, Max phase-to-ground:15.2 kV, AC 1 min:40 kV, DC 15 min:78 kV, Impulse:125 kV, Max corona:19 kV, Test:Yes, 0.75 inch, 1.08 inch, 19.1 mm, 27.4 mm, 3/0 AWG, 4/0 AWG, 20 pack",
                "specificationLabel": "Especificaciones",
                "resourceLabel": "Recursos",
                "familyName": "Eaton Cooper Power series loadbreak elbow",
                "compareLabel": "Compare",
                "marketingDescription": "Eaton’s Cooper Power series 200 A 15, 25 and 35 kV loadbreak elbow connectors and accessories and 600 A 15 and 25 kV Cleer loadbreak technology connect underground cable to transformers, sectionalizing cabinets and junctions. They are ideal for submersible, fully-shielded and insulated plug-in terminations. These connectors are molded using high-quality, peroxide-cured EPDM insulation for reliable field performance",
                "serialFlag": false,
                "serialAuthFlag": false,
                "replacements": [],
                "crossSell": [],
                "upSell": [],
                "images": [],
                "resources": [],
                "status": "Active",
                "label": "LE225CC08T",
                "forPriceSpider": false,
                "forPowerReviews": false,
                "doNotShowProductImages": false
            },
            {
                "attributeGroups": [
                    {
                        "attributeList": []
                    }
                ],
                "attributeTables": [],
                "skuPageUrl": "https://www.eaton.com/mx/es-mx/skuPage.LE225DD07T.html",
                "skuPageSpecificationUrl": "https://www.eaton.com/mx/es-mx/skuPage.LE225DD07T.html#tab-1",
                "skuPageResourcesUrl": "https://www.eaton.com/mx/es-mx/skuPage.LE225DD07T.html#tab-2",
                "desktopRendition": "https://www.eaton.com/mdmfiles/PDM30075040/LE225CC06TX_L/110x110_96dpi",
                "mobileRendition": "https://www.eaton.com/mdmfiles/PDM30075040/LE225CC06TX_L/500x500_72dpi",
                "catalogNumber": "LE225DD07T",
                "modelCode": "",
                "price": "",
                "longDescription": "Eaton Cooper Power series loadbreak elbow, 200 A, Std V:25 kV, Max phase-to-ground:15.2 kV, AC 1 min:40 kV, DC 15 min:78 kV, Impulse:125 kV, Max corona:19 kV, Test:Yes, 0.89 inch, 1.22 inch, 22.6 mm, 30.0 mm, 2/0 AWG, 3/0 AWG, 20 pack",
                "specificationLabel": "Especificaciones",
                "resourceLabel": "Recursos",
                "familyName": "Eaton Cooper Power series loadbreak elbow",
                "compareLabel": "Compare",
                "marketingDescription": "Eaton’s Cooper Power series 200 A 15, 25 and 35 kV loadbreak elbow connectors and accessories and 600 A 15 and 25 kV Cleer loadbreak technology connect underground cable to transformers, sectionalizing cabinets and junctions. They are ideal for submersible, fully-shielded and insulated plug-in terminations. These connectors are molded using high-quality, peroxide-cured EPDM insulation for reliable field performance",
                "serialFlag": false,
                "serialAuthFlag": false,
                "replacements": [],
                "crossSell": [],
                "upSell": [],
                "images": [],
                "resources": [],
                "status": "Active",
                "label": "LE225DD07T",
                "forPriceSpider": false,
                "forPowerReviews": false,
                "doNotShowProductImages": false
            },
            {
                "attributeGroups": [
                    {
                        "attributeList": []
                    }
                ],
                "attributeTables": [],
                "skuPageUrl": "https://www.eaton.com/mx/es-mx/skuPage.LE235B06T.html",
                "skuPageSpecificationUrl": "https://www.eaton.com/mx/es-mx/skuPage.LE235B06T.html#tab-1",
                "skuPageResourcesUrl": "https://www.eaton.com/mx/es-mx/skuPage.LE235B06T.html#tab-2",
                "desktopRendition": "https://www.eaton.com/mdmfiles/PDM26808219/LE235D06TX_C/110x110_96dpi",
                "mobileRendition": "https://www.eaton.com/mdmfiles/PDM26808219/LE235D06TX_C/500x500_72dpi",
                "catalogNumber": "LE235B06T",
                "modelCode": "",
                "price": "",
                "longDescription": "Eaton Cooper Power series loadbreak elbow, 200 A, Std V:35 kV, Max phase-to-ground:21.1 kV, AC 1 min:50 kV, DC 15 min:103 kV, Impulse:150 kV, Max corona:26 kV, Test:Yes, 0.825 inch, 1.00 inch, 20.96 mm, 25.4 mm, 1/0 AWG, 2/0 AWG, 10 pack",
                "specificationLabel": "Especificaciones",
                "resourceLabel": "Recursos",
                "familyName": "Eaton Cooper Power series loadbreak elbow",
                "compareLabel": "Compare",
                "marketingDescription": "Eaton’s Cooper Power series 200 A 15, 25 and 35 kV loadbreak elbow connectors and accessories and 600 A 15 and 25 kV Cleer loadbreak technology connect underground cable to transformers, sectionalizing cabinets and junctions. They are ideal for submersible, fully-shielded and insulated plug-in terminations. These connectors are molded using high-quality, peroxide-cured EPDM insulation for reliable field performance",
                "serialFlag": false,
                "serialAuthFlag": false,
                "replacements": [],
                "crossSell": [],
                "upSell": [],
                "images": [],
                "resources": [],
                "status": "Active",
                "label": "LE235B06T",
                "forPriceSpider": false,
                "forPowerReviews": false,
                "doNotShowProductImages": false
            },
            {
                "attributeGroups": [
                    {
                        "attributeList": []
                    }
                ],
                "attributeTables": [],
                "skuPageUrl": "https://www.eaton.com/mx/es-mx/skuPage.LE235B06TX.html",
                "skuPageSpecificationUrl": "https://www.eaton.com/mx/es-mx/skuPage.LE235B06TX.html#tab-1",
                "skuPageResourcesUrl": "https://www.eaton.com/mx/es-mx/skuPage.LE235B06TX.html#tab-2",
                "desktopRendition": "https://www.eaton.com/mdmfiles/PDM26808219/LE235D06TX_C/110x110_96dpi",
                "mobileRendition": "https://www.eaton.com/mdmfiles/PDM26808219/LE235D06TX_C/500x500_72dpi",
                "catalogNumber": "LE235B06TX",
                "modelCode": "",
                "price": "",
                "longDescription": "Eaton Cooper Power series loadbreak elbow, 200 A, Std V:35 kV, Max phase-to-ground:21.1 kV, AC 1 min:50 kV, DC 15 min:103 kV, Impulse:150 kV, Max corona:26 kV, Test:Yes, 0.825 inch, 1.00 inch, 20.96 mm, 25.4 mm, 1/0 AWG, 2/0 AWG, Single",
                "specificationLabel": "Especificaciones",
                "resourceLabel": "Recursos",
                "familyName": "Eaton Cooper Power series loadbreak elbow",
                "compareLabel": "Compare",
                "marketingDescription": "Eaton’s Cooper Power series 200 A 15, 25 and 35 kV loadbreak elbow connectors and accessories and 600 A 15 and 25 kV Cleer loadbreak technology connect underground cable to transformers, sectionalizing cabinets and junctions. They are ideal for submersible, fully-shielded and insulated plug-in terminations. These connectors are molded using high-quality, peroxide-cured EPDM insulation for reliable field performance",
                "serialFlag": false,
                "serialAuthFlag": false,
                "replacements": [],
                "crossSell": [],
                "upSell": [],
                "images": [],
                "resources": [],
                "status": "Active",
                "label": "LE235B06TX",
                "forPriceSpider": false,
                "forPowerReviews": false,
                "doNotShowProductImages": false
            },
            {
                "attributeGroups": [
                    {
                        "attributeList": []
                    }
                ],
                "attributeTables": [],
                "skuPageUrl": "https://www.eaton.com/mx/es-mx/skuPage.LE235D06.html",
                "skuPageSpecificationUrl": "https://www.eaton.com/mx/es-mx/skuPage.LE235D06.html#tab-1",
                "skuPageResourcesUrl": "https://www.eaton.com/mx/es-mx/skuPage.LE235D06.html#tab-2",
                "desktopRendition": "https://www.eaton.com/mdmfiles/PDM30075047/LE235D05VP_R/110x110_96dpi",
                "mobileRendition": "https://www.eaton.com/mdmfiles/PDM30075047/LE235D05VP_R/500x500_72dpi",
                "catalogNumber": "LE235D06",
                "modelCode": "",
                "price": "",
                "longDescription": "Eaton Cooper Power series loadbreak elbow, 200 A, Std V:35 kV, Max phase-to-ground:21.1 kV, AC 1 min:50 kV, DC 15 min:103 kV, Impulse:150 kV, Max corona:26 kV, Test:No, 0.995 inch, 1.18 inch, 25.27 mm, 29.97 mm, 1/0 AWG, 2/0 AWG, 10 pack",
                "specificationLabel": "Especificaciones",
                "resourceLabel": "Recursos",
                "familyName": "Eaton Cooper Power series loadbreak elbow",
                "compareLabel": "Compare",
                "marketingDescription": "Eaton’s Cooper Power series 200 A 15, 25 and 35 kV loadbreak elbow connectors and accessories and 600 A 15 and 25 kV Cleer loadbreak technology connect underground cable to transformers, sectionalizing cabinets and junctions. They are ideal for submersible, fully-shielded and insulated plug-in terminations. These connectors are molded using high-quality, peroxide-cured EPDM insulation for reliable field performance",
                "serialFlag": false,
                "serialAuthFlag": false,
                "replacements": [],
                "crossSell": [],
                "upSell": [],
                "images": [],
                "resources": [],
                "status": "Active",
                "label": "LE235D06",
                "forPriceSpider": false,
                "forPowerReviews": false,
                "doNotShowProductImages": false
            },
            {
                "attributeGroups": [
                    {
                        "attributeList": []
                    }
                ],
                "attributeTables": [],
                "skuPageUrl": "https://www.eaton.com/mx/es-mx/skuPage.LE235D06CSAX.html",
                "skuPageSpecificationUrl": "https://www.eaton.com/mx/es-mx/skuPage.LE235D06CSAX.html#tab-1",
                "skuPageResourcesUrl": "https://www.eaton.com/mx/es-mx/skuPage.LE235D06CSAX.html#tab-2",
                "desktopRendition": "https://www.eaton.com/mdmfiles/PDM30075045/LE235D05VP_C/110x110_96dpi",
                "mobileRendition": "https://www.eaton.com/mdmfiles/PDM30075045/LE235D05VP_C/500x500_72dpi",
                "catalogNumber": "LE235D06CSAX",
                "modelCode": "",
                "price": "",
                "longDescription": "Eaton Cooper Power series loadbreak elbow,200 A,35 kV,CSA,Box",
                "specificationLabel": "Especificaciones",
                "resourceLabel": "Recursos",
                "familyName": "Eaton Cooper Power series loadbreak elbow",
                "compareLabel": "Compare",
                "marketingDescription": "Eaton’s Cooper Power series 200 A 15, 25 and 35 kV loadbreak elbow connectors and accessories and 600 A 15 and 25 kV Cleer loadbreak technology connect underground cable to transformers, sectionalizing cabinets and junctions. They are ideal for submersible, fully-shielded and insulated plug-in terminations. These connectors are molded using high-quality, peroxide-cured EPDM insulation for reliable field performance",
                "serialFlag": false,
                "serialAuthFlag": false,
                "replacements": [],
                "crossSell": [],
                "upSell": [],
                "images": [],
                "resources": [],
                "status": "Active",
                "label": "LE235D06CSAX",
                "forPriceSpider": false,
                "forPowerReviews": false,
                "doNotShowProductImages": false
            },
            {
                "attributeGroups": [
                    {
                        "attributeList": []
                    }
                ],
                "attributeTables": [],
                "skuPageUrl": "https://www.eaton.com/mx/es-mx/skuPage.LE235D06TX.html",
                "skuPageSpecificationUrl": "https://www.eaton.com/mx/es-mx/skuPage.LE235D06TX.html#tab-1",
                "skuPageResourcesUrl": "https://www.eaton.com/mx/es-mx/skuPage.LE235D06TX.html#tab-2",
                "desktopRendition": "https://www.eaton.com/mdmfiles/PDM26808219/LE235D06TX_C/110x110_96dpi",
                "mobileRendition": "https://www.eaton.com/mdmfiles/PDM26808219/LE235D06TX_C/500x500_72dpi",
                "catalogNumber": "LE235D06TX",
                "modelCode": "",
                "price": "",
                "longDescription": "Eaton Cooper Power series loadbreak elbow, 200 A, Std V:35 kV, Max phase-to-ground:21.1 kV, AC 1 min:50 kV, DC 15 min:103 kV, Impulse:150 kV, Max corona:26 kV, Test:Yes, 0.995 inch, 1.18 inch, 25.27 mm, 29.97 mm, 1/0 AWG, 2/0 AWG, Single",
                "specificationLabel": "Especificaciones",
                "resourceLabel": "Recursos",
                "familyName": "Eaton Cooper Power series loadbreak elbow",
                "compareLabel": "Compare",
                "marketingDescription": "Eaton’s Cooper Power series 200 A 15, 25 and 35 kV loadbreak elbow connectors and accessories and 600 A 15 and 25 kV Cleer loadbreak technology connect underground cable to transformers, sectionalizing cabinets and junctions. They are ideal for submersible, fully-shielded and insulated plug-in terminations. These connectors are molded using high-quality, peroxide-cured EPDM insulation for reliable field performance",
                "serialFlag": false,
                "serialAuthFlag": false,
                "replacements": [],
                "crossSell": [],
                "upSell": [],
                "images": [],
                "resources": [],
                "status": "Active",
                "label": "LE235D06TX",
                "forPriceSpider": false,
                "forPowerReviews": false,
                "doNotShowProductImages": false
            },
            {
                "attributeGroups": [
                    {
                        "attributeList": []
                    }
                ],
                "attributeTables": [],
                "skuPageUrl": "https://www.eaton.com/mx/es-mx/skuPage.LE235F06T.html",
                "skuPageSpecificationUrl": "https://www.eaton.com/mx/es-mx/skuPage.LE235F06T.html#tab-1",
                "skuPageResourcesUrl": "https://www.eaton.com/mx/es-mx/skuPage.LE235F06T.html#tab-2",
                "desktopRendition": "https://www.eaton.com/mdmfiles/PDM26808219/LE235D06TX_C/110x110_96dpi",
                "mobileRendition": "https://www.eaton.com/mdmfiles/PDM26808219/LE235D06TX_C/500x500_72dpi",
                "catalogNumber": "LE235F06T",
                "modelCode": "",
                "price": "",
                "longDescription": "Eaton Cooper Power series loadbreak elbow, 200 A, Std V:35 kV, Max phase-to-ground:21.1 kV, AC 1 min:50 kV, DC 15 min:103 kV, Impulse:150 kV, Max corona:26 kV, Test:Yes, 1.18 inch, 1.34 inch, 29.97 mm, 34.04 mm, 1/0 AWG, 2/0 AWG, 10 pack",
                "specificationLabel": "Especificaciones",
                "resourceLabel": "Recursos",
                "familyName": "Eaton Cooper Power series loadbreak elbow",
                "compareLabel": "Compare",
                "marketingDescription": "Eaton’s Cooper Power series 200 A 15, 25 and 35 kV loadbreak elbow connectors and accessories and 600 A 15 and 25 kV Cleer loadbreak technology connect underground cable to transformers, sectionalizing cabinets and junctions. They are ideal for submersible, fully-shielded and insulated plug-in terminations. These connectors are molded using high-quality, peroxide-cured EPDM insulation for reliable field performance",
                "serialFlag": false,
                "serialAuthFlag": false,
                "replacements": [],
                "crossSell": [],
                "upSell": [],
                "images": [],
                "resources": [],
                "status": "Active",
                "label": "LE235F06T",
                "forPriceSpider": false,
                "forPowerReviews": false,
                "doNotShowProductImages": false
            },
            {
                "attributeGroups": [
                    {
                        "attributeList": []
                    }
                ],
                "attributeTables": [],
                "skuPageUrl": "https://www.eaton.com/mx/es-mx/skuPage.PK225.html",
                "skuPageSpecificationUrl": "https://www.eaton.com/mx/es-mx/skuPage.PK225.html#tab-1",
                "skuPageResourcesUrl": "https://www.eaton.com/mx/es-mx/skuPage.PK225.html#tab-2",
                "desktopRendition": "https://www.eaton.com/mdmfiles/PDM31380725/PK215_C/110x110_96dpi",
                "mobileRendition": "https://www.eaton.com/mdmfiles/PDM31380725/PK215_C/500x500_72dpi",
                "catalogNumber": "PK225",
                "modelCode": "",
                "price": "",
                "longDescription": "Eaton Cooper Power series loadbreak elbow, Probe Kit, 25 kV, 200A, 60Hz, 25 Kilovolts",
                "specificationLabel": "Especificaciones",
                "resourceLabel": "Recursos",
                "familyName": "Eaton Cooper Power series loadbreak elbow",
                "compareLabel": "Compare",
                "marketingDescription": "Eaton’s Cooper Power series 200 A 15, 25 and 35 kV loadbreak elbow connectors and accessories and 600 A 15 and 25 kV Cleer loadbreak technology connect underground cable to transformers, sectionalizing cabinets and junctions. They are ideal for submersible, fully-shielded and insulated plug-in terminations. These connectors are molded using high-quality, peroxide-cured EPDM insulation for reliable field performance",
                "serialFlag": false,
                "serialAuthFlag": false,
                "replacements": [],
                "crossSell": [],
                "upSell": [],
                "images": [],
                "resources": [],
                "status": "Active",
                "label": "PK225",
                "forPriceSpider": false,
                "forPowerReviews": false,
                "doNotShowProductImages": false
            }
        ]
    },
    {
        "url": "https://www.eaton.com/mx/es-mx/catalog/medium-voltage-power-distribution-control-systems/deadbreak-connectors.html",
        "target": "_self",
        "goToProductLabel": "Ir a Conectores de operación sin carga",
        "desktopRendition": "https://www.eaton.com/mdmfiles/PDM31111173/ES-PSD-DEADBREAKCONNECTORS_FM/500x500_72dpi",
        "mobileRendition": "https://www.eaton.com/mdmfiles/PDM31111173/ES-PSD-DEADBREAKCONNECTORS_FM/500x500_72dpi",
        "discontinued": false,
        "discontinuedLabel": "Descontinuado",
        "tobediscontinued": false,
        "tobediscontinuedLabel": "Será descontinuado",
        "newBadgeVisible": false,
        "newBadgeLabel": "Nuevo",
        "showSubCategory": false,
        "subCategoryName": "",
        "showProductDescription": true,
        "productGridDescription": "",
        "productName": "Conectores de operación sin carga",
        "desc": "Los sistemas de conectores de operación sin carga de la serie Cooper Power de Eaton satisfacen la necesidad de una instalación subterránea de frente inactivo en alimentadores principales y laterales. Proporcionan una conexión de cable completamente sumergible, frontal y completamente cubierta para aparatos de media tensión, incluidos transformadores, subestaciones de control y motores grandes. ",
        "models": [
            {
                "attributeGroups": [
                    {
                        "attributeList": []
                    }
                ],
                "attributeTables": [],
                "skuPageUrl": "https://www.eaton.com/mx/es-mx/skuPage.2637019B02.html",
                "skuPageSpecificationUrl": "https://www.eaton.com/mx/es-mx/skuPage.2637019B02.html#tab-1",
                "skuPageResourcesUrl": "https://www.eaton.com/mx/es-mx/skuPage.2637019B02.html#tab-2",
                "desktopRendition": "https://www.eaton.com/mdmfiles/PDM33179351/2637019B02_C/110x110_96dpi",
                "mobileRendition": "https://www.eaton.com/mdmfiles/PDM33179351/2637019B02_C/500x500_72dpi",
                "catalogNumber": "2637019B02",
                "modelCode": "",
                "price": "",
                "longDescription": "Eaton Cooper Power series deadbreak bushing, No gasket, Epoxy, 15/25 kV, Phase to ground: 15.2 kV, AC 1 min: 40 kV, DC 15 min: 78 kV, BIL: 125 kV, Corona: 19 kV, 600 A, No stud, Bulk pack 6",
                "specificationLabel": "Especificaciones",
                "resourceLabel": "Recursos",
                "familyName": "Eaton Cooper Power series deadbreak bushing",
                "compareLabel": "Compare",
                "marketingDescription": "Eaton’s Cooper Power series deadbreak connector systems meet the need for a deadfront underground installation in main and lateral feeders. They provide a completely shielded, deadfront, fully submersible cable connection for medium-voltage apparatus, including transformers, switchgear and large motors.",
                "serialFlag": false,
                "serialAuthFlag": false,
                "replacements": [],
                "crossSell": [],
                "upSell": [],
                "images": [],
                "resources": [],
                "status": "Active",
                "label": "2637019B02",
                "forPriceSpider": false,
                "forPowerReviews": false,
                "doNotShowProductImages": false
            },
            {
                "attributeGroups": [
                    {
                        "attributeList": []
                    }
                ],
                "attributeTables": [],
                "skuPageUrl": "https://www.eaton.com/mx/es-mx/skuPage.BLRTP615A.html",
                "skuPageSpecificationUrl": "https://www.eaton.com/mx/es-mx/skuPage.BLRTP615A.html#tab-1",
                "skuPageResourcesUrl": "https://www.eaton.com/mx/es-mx/skuPage.BLRTP615A.html#tab-2",
                "desktopRendition": "https://www.eaton.com/mdmfiles/PDM26808123/BLRTP615A_C/110x110_96dpi",
                "mobileRendition": "https://www.eaton.com/mdmfiles/PDM26808123/BLRTP615A_C/500x500_72dpi",
                "catalogNumber": "BLRTP615A",
                "modelCode": "",
                "price": "",
                "longDescription": "Eaton Cooper Power series BOL-T loadbreak reducing tap plug, EPDM rubber, 15 kV, Phase to ground: 8.3 kV, AC 1 min: 34 kV, DC 15 min: 53 kV, BIL: 95 kV, 600 A, Corona: 11 kV, Individually bagged",
                "specificationLabel": "Especificaciones",
                "resourceLabel": "Recursos",
                "familyName": "Eaton Cooper Power series BOL-T loadbreak reducing tap plug",
                "compareLabel": "Compare",
                "marketingDescription": "Eaton’s Cooper Power series deadbreak connector systems meet the need for a deadfront underground installation in main and lateral feeders. They provide a completely shielded, deadfront, fully submersible cable connection for medium-voltage apparatus, including transformers, switchgear and large motors.",
                "serialFlag": false,
                "serialAuthFlag": false,
                "replacements": [],
                "crossSell": [],
                "upSell": [],
                "images": [],
                "resources": [],
                "status": "Active",
                "label": "BLRTP615A",
                "forPriceSpider": false,
                "forPowerReviews": false,
                "doNotShowProductImages": false
            },
            {
                "attributeGroups": [
                    {
                        "attributeList": []
                    }
                ],
                "attributeTables": [],
                "skuPageUrl": "https://www.eaton.com/mx/es-mx/skuPage.BLRTP625A.html",
                "skuPageSpecificationUrl": "https://www.eaton.com/mx/es-mx/skuPage.BLRTP625A.html#tab-1",
                "skuPageResourcesUrl": "https://www.eaton.com/mx/es-mx/skuPage.BLRTP625A.html#tab-2",
                "desktopRendition": "https://www.eaton.com/mdmfiles/PDM31046351/BLRTP625A_C/110x110_96dpi",
                "mobileRendition": "https://www.eaton.com/mdmfiles/PDM31046351/BLRTP625A_C/500x500_72dpi",
                "catalogNumber": "BLRTP625A",
                "modelCode": "",
                "price": "",
                "longDescription": "Eaton Cooper Power series BOL-T loadbreak reducing tap plug, EPDM rubber, 25 kV, Phase to ground: 15.2 kV, AC 1 min: 40 kV, DC 15 min: 78 kV, BIL: 125 kV, 600 A, Corona: 19 kV, Individually bagged",
                "specificationLabel": "Especificaciones",
                "resourceLabel": "Recursos",
                "familyName": "Eaton Cooper Power series BOL-T loadbreak reducing tap plug",
                "compareLabel": "Compare",
                "marketingDescription": "Eaton’s Cooper Power series deadbreak connector systems meet the need for a deadfront underground installation in main and lateral feeders. They provide a completely shielded, deadfront, fully submersible cable connection for medium-voltage apparatus, including transformers, switchgear and large motors.",
                "serialFlag": false,
                "serialAuthFlag": false,
                "replacements": [],
                "crossSell": [],
                "upSell": [],
                "images": [],
                "resources": [],
                "status": "Active",
                "label": "BLRTP625A",
                "forPriceSpider": false,
                "forPowerReviews": false,
                "doNotShowProductImages": false
            },
            {
                "attributeGroups": [
                    {
                        "attributeList": []
                    }
                ],
                "attributeTables": [],
                "skuPageUrl": "https://www.eaton.com/mx/es-mx/skuPage.BLRTP635.html",
                "skuPageSpecificationUrl": "https://www.eaton.com/mx/es-mx/skuPage.BLRTP635.html#tab-1",
                "skuPageResourcesUrl": "https://www.eaton.com/mx/es-mx/skuPage.BLRTP635.html#tab-2",
                "desktopRendition": "https://www.eaton.com/mdmfiles/PDM31046353/BLRTP635_C/110x110_96dpi",
                "mobileRendition": "https://www.eaton.com/mdmfiles/PDM31046353/BLRTP635_C/500x500_72dpi",
                "catalogNumber": "BLRTP635",
                "modelCode": "",
                "price": "",
                "longDescription": "Eaton Cooper Power series BOL-T loadbreak reducing tap plug, EPDM rubber, 35 kV, Phase to ground: 21.1 kV, AC 1 min: 50 kV, DC 15 min: 103 kV, BIL: 150 kV, Corona: 26 kV, 900 A, Individually bagged",
                "specificationLabel": "Especificaciones",
                "resourceLabel": "Recursos",
                "familyName": "Eaton Cooper Power series BOL-T loadbreak reducing tap plug",
                "compareLabel": "Compare",
                "marketingDescription": "Eaton’s Cooper Power series deadbreak connector systems meet the need for a deadfront underground installation in main and lateral feeders. They provide a completely shielded, deadfront, fully submersible cable connection for medium-voltage apparatus, including transformers, switchgear and large motors.",
                "serialFlag": false,
                "serialAuthFlag": false,
                "replacements": [],
                "crossSell": [],
                "upSell": [],
                "images": [],
                "resources": [],
                "status": "Active",
                "label": "BLRTP635",
                "forPriceSpider": false,
                "forPowerReviews": false,
                "doNotShowProductImages": false
            },
            {
                "attributeGroups": [
                    {
                        "attributeList": []
                    }
                ],
                "attributeTables": [],
                "skuPageUrl": "https://www.eaton.com/mx/es-mx/skuPage.BT625CC13A1T.html",
                "skuPageSpecificationUrl": "https://www.eaton.com/mx/es-mx/skuPage.BT625CC13A1T.html#tab-1",
                "skuPageResourcesUrl": "https://www.eaton.com/mx/es-mx/skuPage.BT625CC13A1T.html#tab-2",
                "desktopRendition": "https://www.eaton.com/mdmfiles/PDM26808126/BT625CC16A1T_C/110x110_96dpi",
                "mobileRendition": "https://www.eaton.com/mdmfiles/PDM26808126/BT625CC16A1T_C/500x500_72dpi",
                "catalogNumber": "BT625CC13A1T",
                "modelCode": "",
                "price": "",
                "longDescription": "Eaton Cooper Power series BOL-T deadbreak connector, 600A, 25 kV, AC 1 min: 40 kV, DC 15 min: 78 kV, BIL: 125 kV, Min corona: 19 kV, Test point, Cable insul: 0.75-1.08 inch, Strand: 1/0 AWG, Solid: 2/0 AWG, Al lug, Individual box kit",
                "specificationLabel": "Especificaciones",
                "resourceLabel": "Recursos",
                "familyName": "Eaton Cooper Power series BOL-T deadbreak connector",
                "compareLabel": "Compare",
                "marketingDescription": "Eaton’s Cooper Power series deadbreak connector systems meet the need for a deadfront underground installation in main and lateral feeders. They provide a completely shielded, deadfront, fully submersible cable connection for medium-voltage apparatus, including transformers, switchgear and large motors.",
                "serialFlag": false,
                "serialAuthFlag": false,
                "replacements": [],
                "crossSell": [],
                "upSell": [],
                "images": [],
                "resources": [],
                "status": "Active",
                "label": "BT625CC13A1T",
                "forPriceSpider": false,
                "forPowerReviews": false,
                "doNotShowProductImages": false
            },
            {
                "attributeGroups": [
                    {
                        "attributeList": []
                    }
                ],
                "attributeTables": [],
                "skuPageUrl": "https://www.eaton.com/mx/es-mx/skuPage.BT625CC15A1T.html",
                "skuPageSpecificationUrl": "https://www.eaton.com/mx/es-mx/skuPage.BT625CC15A1T.html#tab-1",
                "skuPageResourcesUrl": "https://www.eaton.com/mx/es-mx/skuPage.BT625CC15A1T.html#tab-2",
                "desktopRendition": "https://www.eaton.com/mdmfiles/PDM26808126/BT625CC16A1T_C/110x110_96dpi",
                "mobileRendition": "https://www.eaton.com/mdmfiles/PDM26808126/BT625CC16A1T_C/500x500_72dpi",
                "catalogNumber": "BT625CC15A1T",
                "modelCode": "",
                "price": "",
                "longDescription": "Eaton Cooper Power series BOL-T deadbreak connector, 600A, 25 kV, AC 1 min: 40 kV, DC 15 min: 78 kV, BIL: 125 kV, Min corona: 19 kV, Test point, Cable insul: 0.75-1.08 inch, Strand: 3/0 AWG, Solid: 4/0 AWG, Individual box kit, Al lug",
                "specificationLabel": "Especificaciones",
                "resourceLabel": "Recursos",
                "familyName": "Eaton Cooper Power series BOL-T deadbreak connector",
                "compareLabel": "Compare",
                "marketingDescription": "Eaton’s Cooper Power series deadbreak connector systems meet the need for a deadfront underground installation in main and lateral feeders. They provide a completely shielded, deadfront, fully submersible cable connection for medium-voltage apparatus, including transformers, switchgear and large motors.",
                "serialFlag": false,
                "serialAuthFlag": false,
                "replacements": [],
                "crossSell": [],
                "upSell": [],
                "images": [],
                "resources": [],
                "status": "Active",
                "label": "BT625CC15A1T",
                "forPriceSpider": false,
                "forPowerReviews": false,
                "doNotShowProductImages": false
            },
            {
                "attributeGroups": [
                    {
                        "attributeList": []
                    }
                ],
                "attributeTables": [],
                "skuPageUrl": "https://www.eaton.com/mx/es-mx/skuPage.BT625DD22A1T.html",
                "skuPageSpecificationUrl": "https://www.eaton.com/mx/es-mx/skuPage.BT625DD22A1T.html#tab-1",
                "skuPageResourcesUrl": "https://www.eaton.com/mx/es-mx/skuPage.BT625DD22A1T.html#tab-2",
                "desktopRendition": "https://www.eaton.com/mdmfiles/PDM26808126/BT625CC16A1T_C/110x110_96dpi",
                "mobileRendition": "https://www.eaton.com/mdmfiles/PDM26808126/BT625CC16A1T_C/500x500_72dpi",
                "catalogNumber": "BT625DD22A1T",
                "modelCode": "",
                "price": "",
                "longDescription": "Eaton Cooper Power series BOL-T deadbreak connector, 600A, 25 kV, AC 1 min: 40 kV, DC 15 min: 78 kV, BIL: 125 kV, Min corona: 19 kV, Test point, Cable insul: 0.97-1.31 inch, Strand: 500 kcmil, Solid: 600 kcmil, Al lug, Individual box kit",
                "specificationLabel": "Especificaciones",
                "resourceLabel": "Recursos",
                "familyName": "Eaton Cooper Power series BOL-T deadbreak connector",
                "compareLabel": "Compare",
                "marketingDescription": "Eaton’s Cooper Power series deadbreak connector systems meet the need for a deadfront underground installation in main and lateral feeders. They provide a completely shielded, deadfront, fully submersible cable connection for medium-voltage apparatus, including transformers, switchgear and large motors.",
                "serialFlag": false,
                "serialAuthFlag": false,
                "replacements": [],
                "crossSell": [],
                "upSell": [],
                "images": [],
                "resources": [],
                "status": "Active",
                "label": "BT625DD22A1T",
                "forPriceSpider": false,
                "forPowerReviews": false,
                "doNotShowProductImages": false
            },
            {
                "attributeGroups": [
                    {
                        "attributeList": []
                    }
                ],
                "attributeTables": [],
                "skuPageUrl": "https://www.eaton.com/mx/es-mx/skuPage.BT625EE22A1T.html",
                "skuPageSpecificationUrl": "https://www.eaton.com/mx/es-mx/skuPage.BT625EE22A1T.html#tab-1",
                "skuPageResourcesUrl": "https://www.eaton.com/mx/es-mx/skuPage.BT625EE22A1T.html#tab-2",
                "desktopRendition": "https://www.eaton.com/mdmfiles/PDM26808126/BT625CC16A1T_C/110x110_96dpi",
                "mobileRendition": "https://www.eaton.com/mdmfiles/PDM26808126/BT625CC16A1T_C/500x500_72dpi",
                "catalogNumber": "BT625EE22A1T",
                "modelCode": "",
                "price": "",
                "longDescription": "Eaton Cooper Power series BOL-T deadbreak connector, 600A, 25 kV, AC 1 min: 40 kV, DC 15 min: 78 kV, BIL: 125 kV, Min corona: 19 kV, Test point, Cable insul: 1.09-1.47 inch, Strand: 500 kcmil, Solid: 600 kcmil, Al lug, Individual box kit",
                "specificationLabel": "Especificaciones",
                "resourceLabel": "Recursos",
                "familyName": "Eaton Cooper Power series BOL-T deadbreak connector",
                "compareLabel": "Compare",
                "marketingDescription": "Eaton’s Cooper Power series deadbreak connector systems meet the need for a deadfront underground installation in main and lateral feeders. They provide a completely shielded, deadfront, fully submersible cable connection for medium-voltage apparatus, including transformers, switchgear and large motors.",
                "serialFlag": false,
                "serialAuthFlag": false,
                "replacements": [],
                "crossSell": [],
                "upSell": [],
                "images": [],
                "resources": [],
                "status": "Active",
                "label": "BT625EE22A1T",
                "forPriceSpider": false,
                "forPowerReviews": false,
                "doNotShowProductImages": false
            },
            {
                "attributeGroups": [
                    {
                        "attributeList": []
                    }
                ],
                "attributeTables": [],
                "skuPageUrl": "https://www.eaton.com/mx/es-mx/skuPage.BT625EE22C1T.html",
                "skuPageSpecificationUrl": "https://www.eaton.com/mx/es-mx/skuPage.BT625EE22C1T.html#tab-1",
                "skuPageResourcesUrl": "https://www.eaton.com/mx/es-mx/skuPage.BT625EE22C1T.html#tab-2",
                "desktopRendition": "https://www.eaton.com/mdmfiles/PDM31046356/BT625CC16C1_C/110x110_96dpi",
                "mobileRendition": "https://www.eaton.com/mdmfiles/PDM31046356/BT625CC16C1_C/500x500_72dpi",
                "catalogNumber": "BT625EE22C1T",
                "modelCode": "",
                "price": "",
                "longDescription": "Eaton Cooper Power series BOL-T deadbreak connector, 900A, 25 kV, AC 1 min: 40 kV, DC 15 min: 78 kV, BIL: 125 kV, Min corona: 19 kV, Test point, Cable insul: 1.09-1.47 inch, Strand: 500 kcmil, Solid: 600 kcmil, Al lug, Individual box kit",
                "specificationLabel": "Especificaciones",
                "resourceLabel": "Recursos",
                "familyName": "Eaton Cooper Power series BOL-T deadbreak connector",
                "compareLabel": "Compare",
                "marketingDescription": "Eaton’s Cooper Power series deadbreak connector systems meet the need for a deadfront underground installation in main and lateral feeders. They provide a completely shielded, deadfront, fully submersible cable connection for medium-voltage apparatus, including transformers, switchgear and large motors.",
                "serialFlag": false,
                "serialAuthFlag": false,
                "replacements": [],
                "crossSell": [],
                "upSell": [],
                "images": [],
                "resources": [],
                "status": "Active",
                "label": "BT625EE22C1T",
                "forPriceSpider": false,
                "forPowerReviews": false,
                "doNotShowProductImages": false
            },
            {
                "attributeGroups": [
                    {
                        "attributeList": []
                    }
                ],
                "attributeTables": [],
                "skuPageUrl": "https://www.eaton.com/mx/es-mx/skuPage.BT625FF25A1T.html",
                "skuPageSpecificationUrl": "https://www.eaton.com/mx/es-mx/skuPage.BT625FF25A1T.html#tab-1",
                "skuPageResourcesUrl": "https://www.eaton.com/mx/es-mx/skuPage.BT625FF25A1T.html#tab-2",
                "desktopRendition": "https://www.eaton.com/mdmfiles/PDM26808126/BT625CC16A1T_C/110x110_96dpi",
                "mobileRendition": "https://www.eaton.com/mdmfiles/PDM26808126/BT625CC16A1T_C/500x500_72dpi",
                "catalogNumber": "BT625FF25A1T",
                "modelCode": "",
                "price": "",
                "longDescription": "Eaton Cooper Power series BOL-T deadbreak connector, 600A, 25 kV, AC 1 min: 40 kV, DC 15 min: 78 kV, BIL: 125 kV, Min corona: 19 kV, Test point, Cable insul: 1.26-1.64 inch, Strand: 750 kcmil, Solid: 900 kcmil, Al lug, SA3",
                "specificationLabel": "Especificaciones",
                "resourceLabel": "Recursos",
                "familyName": "Eaton Cooper Power series BOL-T deadbreak connector",
                "compareLabel": "Compare",
                "marketingDescription": "Eaton’s Cooper Power series deadbreak connector systems meet the need for a deadfront underground installation in main and lateral feeders. They provide a completely shielded, deadfront, fully submersible cable connection for medium-voltage apparatus, including transformers, switchgear and large motors.",
                "serialFlag": false,
                "serialAuthFlag": false,
                "replacements": [],
                "crossSell": [],
                "upSell": [],
                "images": [],
                "resources": [],
                "status": "Active",
                "label": "BT625FF25A1T",
                "forPriceSpider": false,
                "forPowerReviews": false,
                "doNotShowProductImages": false
            },
            {
                "attributeGroups": [
                    {
                        "attributeList": []
                    }
                ],
                "attributeTables": [],
                "skuPageUrl": "https://www.eaton.com/mx/es-mx/skuPage.BT625GG25A1T.html",
                "skuPageSpecificationUrl": "https://www.eaton.com/mx/es-mx/skuPage.BT625GG25A1T.html#tab-1",
                "skuPageResourcesUrl": "https://www.eaton.com/mx/es-mx/skuPage.BT625GG25A1T.html#tab-2",
                "desktopRendition": "https://www.eaton.com/mdmfiles/PDM26808126/BT625CC16A1T_C/110x110_96dpi",
                "mobileRendition": "https://www.eaton.com/mdmfiles/PDM26808126/BT625CC16A1T_C/500x500_72dpi",
                "catalogNumber": "BT625GG25A1T",
                "modelCode": "",
                "price": "",
                "longDescription": "Eaton Cooper Power series BOL-T deadbreak connector, 600A, 25 kV, AC 1 min: 40 kV, DC 15 min: 78 kV, BIL: 125 kV, Min corona: 19 kV, Test point, Cable insul: 1.36-1.71 inch, Strand: 750 kcmil, Solid: 900 kcmil, Al lug, Individual box kit",
                "specificationLabel": "Especificaciones",
                "resourceLabel": "Recursos",
                "familyName": "Eaton Cooper Power series BOL-T deadbreak connector",
                "compareLabel": "Compare",
                "marketingDescription": "Eaton’s Cooper Power series deadbreak connector systems meet the need for a deadfront underground installation in main and lateral feeders. They provide a completely shielded, deadfront, fully submersible cable connection for medium-voltage apparatus, including transformers, switchgear and large motors.",
                "serialFlag": false,
                "serialAuthFlag": false,
                "replacements": [],
                "crossSell": [],
                "upSell": [],
                "images": [],
                "resources": [],
                "status": "Active",
                "label": "BT625GG25A1T",
                "forPriceSpider": false,
                "forPowerReviews": false,
                "doNotShowProductImages": false
            },
            {
                "attributeGroups": [
                    {
                        "attributeList": []
                    }
                ],
                "attributeTables": [],
                "skuPageUrl": "https://www.eaton.com/mx/es-mx/skuPage.BT635J12A1TSA2.html",
                "skuPageSpecificationUrl": "https://www.eaton.com/mx/es-mx/skuPage.BT635J12A1TSA2.html#tab-1",
                "skuPageResourcesUrl": "https://www.eaton.com/mx/es-mx/skuPage.BT635J12A1TSA2.html#tab-2",
                "desktopRendition": "https://www.eaton.com/mdmfiles/PDM31111173/ES-PSD-DEADBREAKCONNECTORS_FM/110x110_96dpi",
                "mobileRendition": "https://www.eaton.com/mdmfiles/PDM31111173/ES-PSD-DEADBREAKCONNECTORS_FM/500x500_72dpi",
                "catalogNumber": "BT635J12A1TSA2",
                "modelCode": "",
                "price": "",
                "longDescription": "Eaton Cooper Power series BOL-T deadbreak connector,600A,Individual box kit,35 kV,Stud,Shield",
                "specificationLabel": "Especificaciones",
                "resourceLabel": "Recursos",
                "familyName": "Eaton Cooper Power series BOL-T deadbreak connector",
                "compareLabel": "Compare",
                "marketingDescription": "Eaton’s Cooper Power series deadbreak connector systems meet the need for a deadfront underground installation in main and lateral feeders. They provide a completely shielded, deadfront, fully submersible cable connection for medium-voltage apparatus, including transformers, switchgear and large motors.",
                "serialFlag": false,
                "serialAuthFlag": false,
                "replacements": [],
                "crossSell": [],
                "upSell": [],
                "images": [],
                "resources": [],
                "status": "Active",
                "label": "BT635J12A1TSA2",
                "forPriceSpider": false,
                "forPowerReviews": false,
                "doNotShowProductImages": false
            },
            {
                "attributeGroups": [
                    {
                        "attributeList": []
                    }
                ],
                "attributeTables": [],
                "skuPageUrl": "https://www.eaton.com/mx/es-mx/skuPage.BT638JS1A1T.html",
                "skuPageSpecificationUrl": "https://www.eaton.com/mx/es-mx/skuPage.BT638JS1A1T.html#tab-1",
                "skuPageResourcesUrl": "https://www.eaton.com/mx/es-mx/skuPage.BT638JS1A1T.html#tab-2",
                "desktopRendition": "https://www.eaton.com/mdmfiles/PDM30075004/BT635TS6A1T_R/110x110_96dpi",
                "mobileRendition": "https://www.eaton.com/mdmfiles/PDM30075004/BT635TS6A1T_R/500x500_72dpi",
                "catalogNumber": "BT638JS1A1T",
                "modelCode": "",
                "price": "",
                "longDescription": "Eaton Cooper Power series BOL-T deadbreak connector, 600A, 35 kV, AC 1 min: 50 kV, DC 15 min: 103 kV, BIL: 200 kV, Min corona: 26 kV, Test point, Cable insul: 1.16-1.30 inch, Strand: 1/0 AWG-250 kcmil, Solid: 1/0 AWG-350 kcmil",
                "specificationLabel": "Especificaciones",
                "resourceLabel": "Recursos",
                "familyName": "Eaton Cooper Power series BOL-T deadbreak connector",
                "compareLabel": "Compare",
                "marketingDescription": "Eaton’s Cooper Power series deadbreak connector systems meet the need for a deadfront underground installation in main and lateral feeders. They provide a completely shielded, deadfront, fully submersible cable connection for medium-voltage apparatus, including transformers, switchgear and large motors.",
                "serialFlag": false,
                "serialAuthFlag": false,
                "replacements": [],
                "crossSell": [],
                "upSell": [],
                "images": [],
                "resources": [],
                "status": "Active",
                "label": "BT638JS1A1T",
                "forPriceSpider": false,
                "forPowerReviews": false,
                "doNotShowProductImages": false
            },
            {
                "attributeGroups": [
                    {
                        "attributeList": []
                    }
                ],
                "attributeTables": [],
                "skuPageUrl": "https://www.eaton.com/mx/es-mx/skuPage.BT638MS3A1T.html",
                "skuPageSpecificationUrl": "https://www.eaton.com/mx/es-mx/skuPage.BT638MS3A1T.html#tab-1",
                "skuPageResourcesUrl": "https://www.eaton.com/mx/es-mx/skuPage.BT638MS3A1T.html#tab-2",
                "desktopRendition": "https://www.eaton.com/mdmfiles/PDM30075004/BT635TS6A1T_R/110x110_96dpi",
                "mobileRendition": "https://www.eaton.com/mdmfiles/PDM30075004/BT635TS6A1T_R/500x500_72dpi",
                "catalogNumber": "BT638MS3A1T",
                "modelCode": "",
                "price": "",
                "longDescription": "Eaton Cooper Power series BOL-T deadbreak connector, 600A, 35 kV, AC 1 min: 50 kV, DC 15 min: 103 kV, BIL: 200 kV, Min corona: 26 kV, Test point, Cable insul: 1.35-1.52 inch, Strand: 350-600 kcmil, Solid: 500-700 kcmil, Shear bolt",
                "specificationLabel": "Especificaciones",
                "resourceLabel": "Recursos",
                "familyName": "Eaton Cooper Power series BOL-T deadbreak connector",
                "compareLabel": "Compare",
                "marketingDescription": "Eaton’s Cooper Power series deadbreak connector systems meet the need for a deadfront underground installation in main and lateral feeders. They provide a completely shielded, deadfront, fully submersible cable connection for medium-voltage apparatus, including transformers, switchgear and large motors.",
                "serialFlag": false,
                "serialAuthFlag": false,
                "replacements": [],
                "crossSell": [],
                "upSell": [],
                "images": [],
                "resources": [],
                "status": "Active",
                "label": "BT638MS3A1T",
                "forPriceSpider": false,
                "forPowerReviews": false,
                "doNotShowProductImages": false
            },
            {
                "attributeGroups": [
                    {
                        "attributeList": []
                    }
                ],
                "attributeTables": [],
                "skuPageUrl": "https://www.eaton.com/mx/es-mx/skuPage.BT638TS6A1T.html",
                "skuPageSpecificationUrl": "https://www.eaton.com/mx/es-mx/skuPage.BT638TS6A1T.html#tab-1",
                "skuPageResourcesUrl": "https://www.eaton.com/mx/es-mx/skuPage.BT638TS6A1T.html#tab-2",
                "desktopRendition": "https://www.eaton.com/mdmfiles/PDM30075004/BT635TS6A1T_R/110x110_96dpi",
                "mobileRendition": "https://www.eaton.com/mdmfiles/PDM30075004/BT635TS6A1T_R/500x500_72dpi",
                "catalogNumber": "BT638TS6A1T",
                "modelCode": "",
                "price": "",
                "longDescription": "Eaton Cooper Power series BOL-T deadbreak connector, 600A, 35 kV, AC 1 min: 50 kV, DC 15 min: 103 kV, BIL: 200 kV, Min corona: 26 kV, Test point, Cable insul: 1.84-1.96 inch, Strand: 800-1250 kcmil, Solid: 1000 kcmil, Shear bolt",
                "specificationLabel": "Especificaciones",
                "resourceLabel": "Recursos",
                "familyName": "Eaton Cooper Power series BOL-T deadbreak connector",
                "compareLabel": "Compare",
                "marketingDescription": "Eaton’s Cooper Power series deadbreak connector systems meet the need for a deadfront underground installation in main and lateral feeders. They provide a completely shielded, deadfront, fully submersible cable connection for medium-voltage apparatus, including transformers, switchgear and large motors.",
                "serialFlag": false,
                "serialAuthFlag": false,
                "replacements": [],
                "crossSell": [],
                "upSell": [],
                "images": [],
                "resources": [],
                "status": "Active",
                "label": "BT638TS6A1T",
                "forPriceSpider": false,
                "forPowerReviews": false,
                "doNotShowProductImages": false
            },
            {
                "attributeGroups": [
                    {
                        "attributeList": []
                    }
                ],
                "attributeTables": [],
                "skuPageUrl": "https://www.eaton.com/mx/es-mx/skuPage.CC6A13U.html",
                "skuPageSpecificationUrl": "https://www.eaton.com/mx/es-mx/skuPage.CC6A13U.html#tab-1",
                "skuPageResourcesUrl": "https://www.eaton.com/mx/es-mx/skuPage.CC6A13U.html#tab-2",
                "desktopRendition": "https://www.eaton.com/mdmfiles/PDM26808137/CC6A13U_C/110x110_96dpi",
                "mobileRendition": "https://www.eaton.com/mdmfiles/PDM26808137/CC6A13U_C/500x500_72dpi",
                "catalogNumber": "CC6A13U",
                "modelCode": "",
                "price": "",
                "longDescription": "Eaton Cooper Power series deadbreak crimp connector, One-hole, 11/16\", Pad: Aluminum, Sleeve: Aluminum, 1/0 AWG or kcmil, 2/0 AWG or kcmil, 70 mm² compact or solid, Metallic gray, Unthreaded aluminum compression connector, Length: 5.94\"",
                "specificationLabel": "Especificaciones",
                "resourceLabel": "Recursos",
                "familyName": "Eaton Cooper Power series deadbreak crimp connector",
                "compareLabel": "Compare",
                "marketingDescription": "Eaton’s Cooper Power series deadbreak connector systems meet the need for a deadfront underground installation in main and lateral feeders. They provide a completely shielded, deadfront, fully submersible cable connection for medium-voltage apparatus, including transformers, switchgear and large motors.",
                "serialFlag": false,
                "serialAuthFlag": false,
                "replacements": [],
                "crossSell": [],
                "upSell": [],
                "images": [],
                "resources": [],
                "status": "Active",
                "label": "CC6A13U",
                "forPriceSpider": false,
                "forPowerReviews": false,
                "doNotShowProductImages": false
            },
            {
                "attributeGroups": [
                    {
                        "attributeList": []
                    }
                ],
                "attributeTables": [],
                "skuPageUrl": "https://www.eaton.com/mx/es-mx/skuPage.CC6A14U.html",
                "skuPageSpecificationUrl": "https://www.eaton.com/mx/es-mx/skuPage.CC6A14U.html#tab-1",
                "skuPageResourcesUrl": "https://www.eaton.com/mx/es-mx/skuPage.CC6A14U.html#tab-2",
                "desktopRendition": "https://www.eaton.com/mdmfiles/PDM26808137/CC6A13U_C/110x110_96dpi",
                "mobileRendition": "https://www.eaton.com/mdmfiles/PDM26808137/CC6A13U_C/500x500_72dpi",
                "catalogNumber": "CC6A14U",
                "modelCode": "",
                "price": "",
                "longDescription": "Eaton Cooper Power series deadbreak crimp connector, One-hole, 11/16\", Pad: Aluminum, Sleeve: Aluminum, 2/0 AWG or kcmil, 70 mm² concentric or compressed, Metallic gray, Unthreaded aluminum compression connector, Length: 5.94\"",
                "specificationLabel": "Especificaciones",
                "resourceLabel": "Recursos",
                "familyName": "Eaton Cooper Power series deadbreak crimp connector",
                "compareLabel": "Compare",
                "marketingDescription": "Eaton’s Cooper Power series deadbreak connector systems meet the need for a deadfront underground installation in main and lateral feeders. They provide a completely shielded, deadfront, fully submersible cable connection for medium-voltage apparatus, including transformers, switchgear and large motors.",
                "serialFlag": false,
                "serialAuthFlag": false,
                "replacements": [],
                "crossSell": [],
                "upSell": [],
                "images": [],
                "resources": [],
                "status": "Active",
                "label": "CC6A14U",
                "forPriceSpider": false,
                "forPowerReviews": false,
                "doNotShowProductImages": false
            },
            {
                "attributeGroups": [
                    {
                        "attributeList": []
                    }
                ],
                "attributeTables": [],
                "skuPageUrl": "https://www.eaton.com/mx/es-mx/skuPage.CC6A15U.html",
                "skuPageSpecificationUrl": "https://www.eaton.com/mx/es-mx/skuPage.CC6A15U.html#tab-1",
                "skuPageResourcesUrl": "https://www.eaton.com/mx/es-mx/skuPage.CC6A15U.html#tab-2",
                "desktopRendition": "https://www.eaton.com/mdmfiles/PDM26808137/CC6A13U_C/110x110_96dpi",
                "mobileRendition": "https://www.eaton.com/mdmfiles/PDM26808137/CC6A13U_C/500x500_72dpi",
                "catalogNumber": "CC6A15U",
                "modelCode": "",
                "price": "",
                "longDescription": "Eaton Cooper Power series deadbreak crimp connector, One-hole, 11/16\", Pad: Aluminum, Sleeve: Aluminum, 3/0 AWG or kcmil, 4/0 AWG or kcmil compact or solid, Metallic gray, Unthreaded aluminum compression connector, Length: 5.94\"",
                "specificationLabel": "Especificaciones",
                "resourceLabel": "Recursos",
                "familyName": "Eaton Cooper Power series deadbreak crimp connector",
                "compareLabel": "Compare",
                "marketingDescription": "Eaton’s Cooper Power series deadbreak connector systems meet the need for a deadfront underground installation in main and lateral feeders. They provide a completely shielded, deadfront, fully submersible cable connection for medium-voltage apparatus, including transformers, switchgear and large motors.",
                "serialFlag": false,
                "serialAuthFlag": false,
                "replacements": [],
                "crossSell": [],
                "upSell": [],
                "images": [],
                "resources": [],
                "status": "Active",
                "label": "CC6A15U",
                "forPriceSpider": false,
                "forPowerReviews": false,
                "doNotShowProductImages": false
            },
            {
                "attributeGroups": [
                    {
                        "attributeList": []
                    }
                ],
                "attributeTables": [],
                "skuPageUrl": "https://www.eaton.com/mx/es-mx/skuPage.CC6A16U.html",
                "skuPageSpecificationUrl": "https://www.eaton.com/mx/es-mx/skuPage.CC6A16U.html#tab-1",
                "skuPageResourcesUrl": "https://www.eaton.com/mx/es-mx/skuPage.CC6A16U.html#tab-2",
                "desktopRendition": "https://www.eaton.com/mdmfiles/PDM26808137/CC6A13U_C/110x110_96dpi",
                "mobileRendition": "https://www.eaton.com/mdmfiles/PDM26808137/CC6A13U_C/500x500_72dpi",
                "catalogNumber": "CC6A16U",
                "modelCode": "",
                "price": "",
                "longDescription": "Eaton Cooper Power series deadbreak crimp connector, One-hole, 11/16\", Pad: Aluminum, Sleeve: Aluminum, 250 AWG or kcmil, 120 mm² compact or solid, Metallic gray, Unthreaded aluminum compression connector, Length: 5.94\"",
                "specificationLabel": "Especificaciones",
                "resourceLabel": "Recursos",
                "familyName": "Eaton Cooper Power series deadbreak crimp connector",
                "compareLabel": "Compare",
                "marketingDescription": "Eaton’s Cooper Power series deadbreak connector systems meet the need for a deadfront underground installation in main and lateral feeders. They provide a completely shielded, deadfront, fully submersible cable connection for medium-voltage apparatus, including transformers, switchgear and large motors.",
                "serialFlag": false,
                "serialAuthFlag": false,
                "replacements": [],
                "crossSell": [],
                "upSell": [],
                "images": [],
                "resources": [],
                "status": "Active",
                "label": "CC6A16U",
                "forPriceSpider": false,
                "forPowerReviews": false,
                "doNotShowProductImages": false
            },
            {
                "attributeGroups": [
                    {
                        "attributeList": []
                    }
                ],
                "attributeTables": [],
                "skuPageUrl": "https://www.eaton.com/mx/es-mx/skuPage.CC6A22U.html",
                "skuPageSpecificationUrl": "https://www.eaton.com/mx/es-mx/skuPage.CC6A22U.html#tab-1",
                "skuPageResourcesUrl": "https://www.eaton.com/mx/es-mx/skuPage.CC6A22U.html#tab-2",
                "desktopRendition": "https://www.eaton.com/mdmfiles/PDM26808137/CC6A13U_C/110x110_96dpi",
                "mobileRendition": "https://www.eaton.com/mdmfiles/PDM26808137/CC6A13U_C/500x500_72dpi",
                "catalogNumber": "CC6A22U",
                "modelCode": "",
                "price": "",
                "longDescription": "Eaton Cooper Power series deadbreak crimp connector, One-hole, 11/16\", Pad: Aluminum, Sleeve: Aluminum, 600 AWG or kcmil, 300 mm² compact or solid, Metallic gray, Unthreaded aluminum compression connector, Length: 5.94\"",
                "specificationLabel": "Especificaciones",
                "resourceLabel": "Recursos",
                "familyName": "Eaton Cooper Power series deadbreak crimp connector",
                "compareLabel": "Compare",
                "marketingDescription": "Eaton’s Cooper Power series deadbreak connector systems meet the need for a deadfront underground installation in main and lateral feeders. They provide a completely shielded, deadfront, fully submersible cable connection for medium-voltage apparatus, including transformers, switchgear and large motors.",
                "serialFlag": false,
                "serialAuthFlag": false,
                "replacements": [],
                "crossSell": [],
                "upSell": [],
                "images": [],
                "resources": [],
                "status": "Active",
                "label": "CC6A22U",
                "forPriceSpider": false,
                "forPowerReviews": false,
                "doNotShowProductImages": false
            },
            {
                "attributeGroups": [
                    {
                        "attributeList": []
                    }
                ],
                "attributeTables": [],
                "skuPageUrl": "https://www.eaton.com/mx/es-mx/skuPage.CC6A25U.html",
                "skuPageSpecificationUrl": "https://www.eaton.com/mx/es-mx/skuPage.CC6A25U.html#tab-1",
                "skuPageResourcesUrl": "https://www.eaton.com/mx/es-mx/skuPage.CC6A25U.html#tab-2",
                "desktopRendition": "https://www.eaton.com/mdmfiles/PDM26808137/CC6A13U_C/110x110_96dpi",
                "mobileRendition": "https://www.eaton.com/mdmfiles/PDM26808137/CC6A13U_C/500x500_72dpi",
                "catalogNumber": "CC6A25U",
                "modelCode": "",
                "price": "",
                "longDescription": "Eaton Cooper Power series deadbreak crimp connector, One-hole, 11/16\", Pad: Aluminum, Sleeve: Aluminum, 750 AWG or kcmil, 900 AWG or kcmil, compact or solid, Metallic gray, Unthreaded aluminum compression connector, Length: 5.94\"",
                "specificationLabel": "Especificaciones",
                "resourceLabel": "Recursos",
                "familyName": "Eaton Cooper Power series deadbreak crimp connector",
                "compareLabel": "Compare",
                "marketingDescription": "Eaton’s Cooper Power series deadbreak connector systems meet the need for a deadfront underground installation in main and lateral feeders. They provide a completely shielded, deadfront, fully submersible cable connection for medium-voltage apparatus, including transformers, switchgear and large motors.",
                "serialFlag": false,
                "serialAuthFlag": false,
                "replacements": [],
                "crossSell": [],
                "upSell": [],
                "images": [],
                "resources": [],
                "status": "Active",
                "label": "CC6A25U",
                "forPriceSpider": false,
                "forPowerReviews": false,
                "doNotShowProductImages": false
            },
            {
                "attributeGroups": [
                    {
                        "attributeList": []
                    }
                ],
                "attributeTables": [],
                "skuPageUrl": "https://www.eaton.com/mx/es-mx/skuPage.CC6C13U.html",
                "skuPageSpecificationUrl": "https://www.eaton.com/mx/es-mx/skuPage.CC6C13U.html#tab-1",
                "skuPageResourcesUrl": "https://www.eaton.com/mx/es-mx/skuPage.CC6C13U.html#tab-2",
                "desktopRendition": "https://www.eaton.com/mdmfiles/PDM26808140/CC6C22U_C/110x110_96dpi",
                "mobileRendition": "https://www.eaton.com/mdmfiles/PDM26808140/CC6C22U_C/500x500_72dpi",
                "catalogNumber": "CC6C13U",
                "modelCode": "",
                "price": "",
                "longDescription": "Eaton Cooper Power series deadbreak crimp connector, One-hole, 11/16\", Pad: Copper, Sleeve: Aluminum, 1/0 AWG or kcmil, 70 mm² compact or solid, Metallic gray and orange, Unthreaded coppertop compression connector, Length: 5.94\"",
                "specificationLabel": "Especificaciones",
                "resourceLabel": "Recursos",
                "familyName": "Eaton Cooper Power series deadbreak crimp connector",
                "compareLabel": "Compare",
                "marketingDescription": "Eaton’s Cooper Power series deadbreak connector systems meet the need for a deadfront underground installation in main and lateral feeders. They provide a completely shielded, deadfront, fully submersible cable connection for medium-voltage apparatus, including transformers, switchgear and large motors.",
                "serialFlag": false,
                "serialAuthFlag": false,
                "replacements": [],
                "crossSell": [],
                "upSell": [],
                "images": [],
                "resources": [],
                "status": "Active",
                "label": "CC6C13U",
                "forPriceSpider": false,
                "forPowerReviews": false,
                "doNotShowProductImages": false
            },
            {
                "attributeGroups": [
                    {
                        "attributeList": []
                    }
                ],
                "attributeTables": [],
                "skuPageUrl": "https://www.eaton.com/mx/es-mx/skuPage.DBE625.html",
                "skuPageSpecificationUrl": "https://www.eaton.com/mx/es-mx/skuPage.DBE625.html#tab-1",
                "skuPageResourcesUrl": "https://www.eaton.com/mx/es-mx/skuPage.DBE625.html#tab-2",
                "desktopRendition": "https://www.eaton.com/mdmfiles/PDM30075011/DBE625_C/110x110_96dpi",
                "mobileRendition": "https://www.eaton.com/mdmfiles/PDM30075011/DBE625_C/500x500_72dpi",
                "catalogNumber": "DBE625",
                "modelCode": "",
                "price": "",
                "longDescription": "Eaton Cooper Power series bushing extender, Voltage rating: 15/25 kV, Operating interface: 600A",
                "specificationLabel": "Especificaciones",
                "resourceLabel": "Recursos",
                "familyName": "Eaton Cooper Power series bushing extender",
                "compareLabel": "Compare",
                "marketingDescription": "Eaton’s Cooper Power series deadbreak connector systems meet the need for a deadfront underground installation in main and lateral feeders. They provide a completely shielded, deadfront, fully submersible cable connection for medium-voltage apparatus, including transformers, switchgear and large motors.",
                "serialFlag": false,
                "serialAuthFlag": false,
                "replacements": [],
                "crossSell": [],
                "upSell": [],
                "images": [],
                "resources": [],
                "status": "Active",
                "label": "DBE625",
                "forPriceSpider": false,
                "forPowerReviews": false,
                "doNotShowProductImages": false
            },
            {
                "attributeGroups": [
                    {
                        "attributeList": []
                    }
                ],
                "attributeTables": [],
                "skuPageUrl": "https://www.eaton.com/mx/es-mx/skuPage.DCP625A.html",
                "skuPageSpecificationUrl": "https://www.eaton.com/mx/es-mx/skuPage.DCP625A.html#tab-1",
                "skuPageResourcesUrl": "https://www.eaton.com/mx/es-mx/skuPage.DCP625A.html#tab-2",
                "desktopRendition": "https://www.eaton.com/mdmfiles/PDM31017396/DCP625A_C/110x110_96dpi",
                "mobileRendition": "https://www.eaton.com/mdmfiles/PDM31017396/DCP625A_C/500x500_72dpi",
                "catalogNumber": "DCP625A",
                "modelCode": "",
                "price": "",
                "longDescription": "Eaton Cooper Power series connecting plug, Continuous current 600 A, 15/25 kV, EPDM rubber, Phase to ground: 15.2 kV, AC 1 min: 40 kV, DC 15 min: 78 kV, BIL: 125 kV, Corona: 19 kV, Thread size: 5/8-11, Cap, no stud, Al",
                "specificationLabel": "Especificaciones",
                "resourceLabel": "Recursos",
                "familyName": "Eaton Cooper Power series connecting plug",
                "compareLabel": "Compare",
                "marketingDescription": "Eaton’s Cooper Power series deadbreak connector systems meet the need for a deadfront underground installation in main and lateral feeders. They provide a completely shielded, deadfront, fully submersible cable connection for medium-voltage apparatus, including transformers, switchgear and large motors.",
                "serialFlag": false,
                "serialAuthFlag": false,
                "replacements": [],
                "crossSell": [],
                "upSell": [],
                "images": [],
                "resources": [],
                "status": "Active",
                "label": "DCP625A",
                "forPriceSpider": false,
                "forPowerReviews": false,
                "doNotShowProductImages": false
            },
            {
                "attributeGroups": [
                    {
                        "attributeList": []
                    }
                ],
                "attributeTables": [],
                "skuPageUrl": "https://www.eaton.com/mx/es-mx/skuPage.DIP625A.html",
                "skuPageSpecificationUrl": "https://www.eaton.com/mx/es-mx/skuPage.DIP625A.html#tab-1",
                "skuPageResourcesUrl": "https://www.eaton.com/mx/es-mx/skuPage.DIP625A.html#tab-2",
                "desktopRendition": "https://www.eaton.com/mdmfiles/PDM31017416/DIP625A_C/110x110_96dpi",
                "mobileRendition": "https://www.eaton.com/mdmfiles/PDM31017416/DIP625A_C/500x500_72dpi",
                "catalogNumber": "DIP625A",
                "modelCode": "",
                "price": "",
                "longDescription": "Eaton Cooper Power series insulating plug, 15/25 kV, Epoxy, Phase to ground: 15.2 kV, AC 1 min: 40 kV, DC 15 min: 78 kV, BIL: 125 kV, Corona: 19 kV, Thread size: 5/8-11, Cap, no stud, Al",
                "specificationLabel": "Especificaciones",
                "resourceLabel": "Recursos",
                "familyName": "Eaton Cooper Power series insulating plug",
                "compareLabel": "Compare",
                "marketingDescription": "Eaton’s Cooper Power series deadbreak connector systems meet the need for a deadfront underground installation in main and lateral feeders. They provide a completely shielded, deadfront, fully submersible cable connection for medium-voltage apparatus, including transformers, switchgear and large motors.",
                "serialFlag": false,
                "serialAuthFlag": false,
                "replacements": [],
                "crossSell": [],
                "upSell": [],
                "images": [],
                "resources": [],
                "status": "Active",
                "label": "DIP625A",
                "forPriceSpider": false,
                "forPowerReviews": false,
                "doNotShowProductImages": false
            },
            {
                "attributeGroups": [
                    {
                        "attributeList": []
                    }
                ],
                "attributeTables": [],
                "skuPageUrl": "https://www.eaton.com/mx/es-mx/skuPage.DIP625AS.html",
                "skuPageSpecificationUrl": "https://www.eaton.com/mx/es-mx/skuPage.DIP625AS.html#tab-1",
                "skuPageResourcesUrl": "https://www.eaton.com/mx/es-mx/skuPage.DIP625AS.html#tab-2",
                "desktopRendition": "https://www.eaton.com/mdmfiles/PDM31017417/DIP625A_L/110x110_96dpi",
                "mobileRendition": "https://www.eaton.com/mdmfiles/PDM31017417/DIP625A_L/500x500_72dpi",
                "catalogNumber": "DIP625AS",
                "modelCode": "",
                "price": "",
                "longDescription": "Eaton Cooper Power series insulating plug, 15/25 kV, Epoxy, Phase to ground: 15.2 kV, AC 1 min: 40 kV, DC 15 min: 78 kV, BIL: 125 kV, Corona: 19 kV, Thread size: 5/8-11, Cap and stud, Al",
                "specificationLabel": "Especificaciones",
                "resourceLabel": "Recursos",
                "familyName": "Eaton Cooper Power series insulating plug",
                "compareLabel": "Compare",
                "marketingDescription": "Eaton’s Cooper Power series deadbreak connector systems meet the need for a deadfront underground installation in main and lateral feeders. They provide a completely shielded, deadfront, fully submersible cable connection for medium-voltage apparatus, including transformers, switchgear and large motors.",
                "serialFlag": false,
                "serialAuthFlag": false,
                "replacements": [],
                "crossSell": [],
                "upSell": [],
                "images": [],
                "resources": [],
                "status": "Active",
                "label": "DIP625AS",
                "forPriceSpider": false,
                "forPowerReviews": false,
                "doNotShowProductImages": false
            },
            {
                "attributeGroups": [
                    {
                        "attributeList": []
                    }
                ],
                "attributeTables": [],
                "skuPageUrl": "https://www.eaton.com/mx/es-mx/skuPage.DIP635A.html",
                "skuPageSpecificationUrl": "https://www.eaton.com/mx/es-mx/skuPage.DIP635A.html#tab-1",
                "skuPageResourcesUrl": "https://www.eaton.com/mx/es-mx/skuPage.DIP635A.html#tab-2",
                "desktopRendition": "https://www.eaton.com/mdmfiles/PDM31017421/DIP635A_C/110x110_96dpi",
                "mobileRendition": "https://www.eaton.com/mdmfiles/PDM31017421/DIP635A_C/500x500_72dpi",
                "catalogNumber": "DIP635A",
                "modelCode": "",
                "price": "",
                "longDescription": "Eaton Cooper Power series insulating plug, 35 kV, Epoxy, AC 1 min: 50 kV, Phase to ground: 21.1 kV, DC 15 min: 103 kV, BIL: 150 kV, Corona: 126 kV, Thread size: 5/8-11, Cap, no stud, Al",
                "specificationLabel": "Especificaciones",
                "resourceLabel": "Recursos",
                "familyName": "Eaton Cooper Power series insulating plug",
                "compareLabel": "Compare",
                "marketingDescription": "Eaton’s Cooper Power series deadbreak connector systems meet the need for a deadfront underground installation in main and lateral feeders. They provide a completely shielded, deadfront, fully submersible cable connection for medium-voltage apparatus, including transformers, switchgear and large motors.",
                "serialFlag": false,
                "serialAuthFlag": false,
                "replacements": [],
                "crossSell": [],
                "upSell": [],
                "images": [],
                "resources": [],
                "status": "Active",
                "label": "DIP635A",
                "forPriceSpider": false,
                "forPowerReviews": false,
                "doNotShowProductImages": false
            },
            {
                "attributeGroups": [
                    {
                        "attributeList": []
                    }
                ],
                "attributeTables": [],
                "skuPageUrl": "https://www.eaton.com/mx/es-mx/skuPage.DPC625.html",
                "skuPageSpecificationUrl": "https://www.eaton.com/mx/es-mx/skuPage.DPC625.html#tab-1",
                "skuPageResourcesUrl": "https://www.eaton.com/mx/es-mx/skuPage.DPC625.html#tab-2",
                "desktopRendition": "https://www.eaton.com/mdmfiles/PDM31017478/DPC625_C/110x110_96dpi",
                "mobileRendition": "https://www.eaton.com/mdmfiles/PDM31017478/DPC625_C/500x500_72dpi",
                "catalogNumber": "DPC625",
                "modelCode": "",
                "price": "",
                "longDescription": "Eaton Cooper Power series deadbreak protective cap, Drain wire with permanent studs, 15/25 kV, Phase to ground: 15.2 kV, AC 1 min: 40.0 kV, DC 15 min: 78.0 kV, BIL: 125.0 kV, Min corona: 19.0 kV, 15 Kit bulk pack, 600 A",
                "specificationLabel": "Especificaciones",
                "resourceLabel": "Recursos",
                "familyName": "Eaton Cooper Power series deadbreak protective cap",
                "compareLabel": "Compare",
                "marketingDescription": "Eaton’s Cooper Power series deadbreak connector systems meet the need for a deadfront underground installation in main and lateral feeders. They provide a completely shielded, deadfront, fully submersible cable connection for medium-voltage apparatus, including transformers, switchgear and large motors.",
                "serialFlag": false,
                "serialAuthFlag": false,
                "replacements": [],
                "crossSell": [],
                "upSell": [],
                "images": [],
                "resources": [],
                "status": "Active",
                "label": "DPC625",
                "forPriceSpider": false,
                "forPowerReviews": false,
                "doNotShowProductImages": false
            },
            {
                "attributeGroups": [
                    {
                        "attributeList": []
                    }
                ],
                "attributeTables": [],
                "skuPageUrl": "https://www.eaton.com/mx/es-mx/skuPage.DPC638X.html",
                "skuPageSpecificationUrl": "https://www.eaton.com/mx/es-mx/skuPage.DPC638X.html#tab-1",
                "skuPageResourcesUrl": "https://www.eaton.com/mx/es-mx/skuPage.DPC638X.html#tab-2",
                "desktopRendition": "https://www.eaton.com/mdmfiles/PDM31380630/DPC635_C/110x110_96dpi",
                "mobileRendition": "https://www.eaton.com/mdmfiles/PDM31380630/DPC635_C/500x500_72dpi",
                "catalogNumber": "DPC638X",
                "modelCode": "",
                "price": "",
                "longDescription": "Eaton Cooper Power series deadbreak protective cap, Drain wire with permanent studs, 35 kV, Phase to ground: 21.1 kV, AC 1 min: 50.0 kV, DC 15 min: 103.0 kV, BIL: 200.0 kV, Min corona: 26.0 kV, Individual box kit, 600 A",
                "specificationLabel": "Especificaciones",
                "resourceLabel": "Recursos",
                "familyName": "Eaton Cooper Power series deadbreak protective cap",
                "compareLabel": "Compare",
                "marketingDescription": "Eaton’s Cooper Power series deadbreak connector systems meet the need for a deadfront underground installation in main and lateral feeders. They provide a completely shielded, deadfront, fully submersible cable connection for medium-voltage apparatus, including transformers, switchgear and large motors.",
                "serialFlag": false,
                "serialAuthFlag": false,
                "replacements": [],
                "crossSell": [],
                "upSell": [],
                "images": [],
                "resources": [],
                "status": "Active",
                "label": "DPC638X",
                "forPriceSpider": false,
                "forPowerReviews": false,
                "doNotShowProductImages": false
            },
            {
                "attributeGroups": [
                    {
                        "attributeList": []
                    }
                ],
                "attributeTables": [],
                "skuPageUrl": "https://www.eaton.com/mx/es-mx/skuPage.DT625.html",
                "skuPageSpecificationUrl": "https://www.eaton.com/mx/es-mx/skuPage.DT625.html#tab-1",
                "skuPageResourcesUrl": "https://www.eaton.com/mx/es-mx/skuPage.DT625.html#tab-2",
                "desktopRendition": "https://www.eaton.com/mdmfiles/PDM31380655/DT625_C/110x110_96dpi",
                "mobileRendition": "https://www.eaton.com/mdmfiles/PDM31380655/DT625_C/500x500_72dpi",
                "catalogNumber": "DT625",
                "modelCode": "",
                "price": "",
                "longDescription": "Eaton Cooper Power series BOL-T deadbreak connector, 600A, 25 kV, AC 1 min: 40 kV, DC 15 min: 78 kV, BIL: 125 kV, Min corona: 19 kV, No test point, Cable insul: No cable adapter, Individual box kit, No connector",
                "specificationLabel": "Especificaciones",
                "resourceLabel": "Recursos",
                "familyName": "Eaton Cooper Power series BOL-T deadbreak connector",
                "compareLabel": "Compare",
                "marketingDescription": "Eaton’s Cooper Power series deadbreak connector systems meet the need for a deadfront underground installation in main and lateral feeders. They provide a completely shielded, deadfront, fully submersible cable connection for medium-voltage apparatus, including transformers, switchgear and large motors.",
                "serialFlag": false,
                "serialAuthFlag": false,
                "replacements": [],
                "crossSell": [],
                "upSell": [],
                "images": [],
                "resources": [],
                "status": "Active",
                "label": "DT625",
                "forPriceSpider": false,
                "forPowerReviews": false,
                "doNotShowProductImages": false
            }
        ]
    },
    {
        "url": "https://www.eaton.com/mx/es-mx/catalog/medium-voltage-power-distribution-control-systems/insulated-splices.html",
        "target": "_self",
        "goToProductLabel": "Ir a Empalmes aislados",
        "desktopRendition": "https://www.eaton.com/mdmfiles/PDM31113422/SP25C004_C/500x500_72dpi",
        "mobileRendition": "https://www.eaton.com/mdmfiles/PDM31113422/SP25C004_C/500x500_72dpi",
        "discontinued": false,
        "discontinuedLabel": "Descontinuado",
        "tobediscontinued": false,
        "tobediscontinuedLabel": "Será descontinuado",
        "newBadgeVisible": false,
        "newBadgeLabel": "Nuevo",
        "showSubCategory": false,
        "subCategoryName": "",
        "showProductDescription": true,
        "productGridDescription": "",
        "productName": "Empalmes aislados",
        "desc": "Los empalmes de la serie Cooper Power de Eaton a 15, 25 y 35 kV proporcionan una unión de cable permanente, completamente apantallada y totalmente sumergible e incluyen ventajas para aplicaciones típicas de reparación, reemplazo o extensión de cables subterráneos de alto voltaje.",
        "models": []
    },
    {
        "url": "https://www.eaton.com/mx/es-mx/catalog/medium-voltage-power-distribution-control-systems/secter-cabinets-and-ground-sleeves.html",
        "target": "_self",
        "goToProductLabel": "Ir a Gabinetes SecTER y manguitos de conexión a tierra",
        "desktopRendition": "https://www.eaton.com/mdmfiles/PDM39166866/SEC36623F2154M0G_C/500x500_72dpi",
        "mobileRendition": "https://www.eaton.com/mdmfiles/PDM39166866/SEC36623F2154M0G_C/500x500_72dpi",
        "discontinued": false,
        "discontinuedLabel": "Descontinuado",
        "tobediscontinued": false,
        "tobediscontinuedLabel": "Será descontinuado",
        "newBadgeVisible": false,
        "newBadgeLabel": "Nuevo",
        "showSubCategory": false,
        "subCategoryName": "",
        "showProductDescription": true,
        "productGridDescription": "",
        "productName": "Gabinetes SecTER y manguitos de conexión a tierra",
        "desc": "Los gabinetes SecTER monofásicos y trifásicos de la serie Cooper Power de Eaton se utilizan en centros de seccionamiento de cables.",
        "models": [
            {
                "attributeGroups": [
                    {
                        "attributeList": []
                    }
                ],
                "attributeTables": [],
                "skuPageUrl": "https://www.eaton.com/mx/es-mx/skuPage.SEC39833F0000MGG.html",
                "skuPageSpecificationUrl": "https://www.eaton.com/mx/es-mx/skuPage.SEC39833F0000MGG.html#tab-1",
                "skuPageResourcesUrl": "https://www.eaton.com/mx/es-mx/skuPage.SEC39833F0000MGG.html#tab-2",
                "desktopRendition": "https://www.eaton.com/mdmfiles/PDM39166866/SEC36623F2154M0G_C/110x110_96dpi",
                "mobileRendition": "https://www.eaton.com/mdmfiles/PDM39166866/SEC36623F2154M0G_C/500x500_72dpi",
                "catalogNumber": "SEC39833F0000MGG",
                "modelCode": "",
                "price": "",
                "longDescription": "Eaton Cooper Power series SecTER sectionalizing cabinet,Three-phase, Munsell green,7GY3.29/1.5,Mild steel,30\",98\",30\", Flat, Junction type: 15/25 kV, 4-way 600A junctions w/U-straps,with ground rod,ground nuts (1/2-13), Secter Box Asy 98 LG",
                "specificationLabel": "Especificaciones",
                "resourceLabel": "Recursos",
                "familyName": "Eaton Cooper Power series SecTER sectionalizing cabinet",
                "compareLabel": "Compare",
                "marketingDescription": "Eaton's Cooper Power series versatile single- and three-phase sectionalizing cabinets are designed as cable sectionalizing centers, or as permanent or temporary transformer pad covers. The aesthetic low profile design provides unobtrusive installations for sectionalizing, tapping or terminating underground cable. The top hinged diagonally cut removable cover and cabinet are designed for easy one man opening. Recessed door and low sill provides improved access to interior terminations. A door stop prevents the door from accidentally closing. TGIC powder coating exceeds ANSI® coating requirements.",
                "serialFlag": false,
                "serialAuthFlag": false,
                "replacements": [],
                "crossSell": [],
                "upSell": [],
                "images": [],
                "resources": [],
                "status": "Active",
                "label": "SEC39833F0000MGG",
                "forPriceSpider": false,
                "forPowerReviews": false,
                "doNotShowProductImages": false
            }
        ]
    },
    {
        "url": "https://www.eaton.com/mx/es-mx/catalog/medium-voltage-power-distribution-control-systems/elbow-arresters.html",
        "target": "_self",
        "goToProductLabel": "Ir a Supresores de codo",
        "desktopRendition": "https://www.eaton.com/mdmfiles/PDM31111265/ES-PSD-ELBOWARRESTERS_FM/500x500_72dpi",
        "mobileRendition": "https://www.eaton.com/mdmfiles/PDM31111265/ES-PSD-ELBOWARRESTERS_FM/500x500_72dpi",
        "discontinued": false,
        "discontinuedLabel": "Descontinuado",
        "tobediscontinued": false,
        "tobediscontinuedLabel": "Será descontinuado",
        "newBadgeVisible": false,
        "newBadgeLabel": "Nuevo",
        "showSubCategory": false,
        "subCategoryName": "",
        "showProductDescription": true,
        "productGridDescription": "",
        "productName": "Supresores de codo",
        "desc": "Los supresores de codo de la serie Cooper Power de Eaton proporcionan protección de supresor de frente inactivo blindado con el codo apartarrayo de óxido metalicoso y los supresores de pie de estacionamiento utilizados en gabinetes de entrada y transformadores pedestal, bóvedas, cajas de conmutación y otras instalaciones. ",
        "models": [
            {
                "attributeGroups": [
                    {
                        "attributeList": []
                    }
                ],
                "attributeTables": [],
                "skuPageUrl": "https://www.eaton.com/mx/es-mx/skuPage.3237686C10M.html",
                "skuPageSpecificationUrl": "https://www.eaton.com/mx/es-mx/skuPage.3237686C10M.html#tab-1",
                "skuPageResourcesUrl": "https://www.eaton.com/mx/es-mx/skuPage.3237686C10M.html#tab-2",
                "desktopRendition": "https://www.eaton.com/mdmfiles/PDM26807834/3238019C18M_C/110x110_96dpi",
                "mobileRendition": "https://www.eaton.com/mdmfiles/PDM26807834/3238019C18M_C/500x500_72dpi",
                "catalogNumber": "3237686C10M",
                "modelCode": "",
                "price": "",
                "longDescription": "Eaton Cooper Power series parking stand, 15 kV, 200A loadbreak bushing, MCOV: 8.4 kV, Duty cycle: 10 kV, Ground lead: 36 inch, #4 AWG copper lead",
                "specificationLabel": "Especificaciones",
                "resourceLabel": "Recursos",
                "familyName": "Eaton Cooper Power series parking stand",
                "compareLabel": "Compare",
                "marketingDescription": "Eaton’s Cooper Power series elbow arresters provide shielded deadfront arrester protection with metal oxide varistor elbow and parking stand arresters used in pad-mounted, transformer and entry cabinets, vaults, switching enclosures and other installations",
                "serialFlag": false,
                "serialAuthFlag": false,
                "replacements": [],
                "crossSell": [],
                "upSell": [],
                "images": [],
                "resources": [],
                "status": "Active",
                "label": "3237686C10M",
                "forPriceSpider": false,
                "forPowerReviews": false,
                "doNotShowProductImages": false
            },
            {
                "attributeGroups": [
                    {
                        "attributeList": []
                    }
                ],
                "attributeTables": [],
                "skuPageUrl": "https://www.eaton.com/mx/es-mx/skuPage.3237758C18M.html",
                "skuPageSpecificationUrl": "https://www.eaton.com/mx/es-mx/skuPage.3237758C18M.html#tab-1",
                "skuPageResourcesUrl": "https://www.eaton.com/mx/es-mx/skuPage.3237758C18M.html#tab-2",
                "desktopRendition": "https://www.eaton.com/mdmfiles/PDM26807828/3237758C18M_C/110x110_96dpi",
                "mobileRendition": "https://www.eaton.com/mdmfiles/PDM26807828/3237758C18M_C/500x500_72dpi",
                "catalogNumber": "3237758C18M",
                "modelCode": "",
                "price": "",
                "longDescription": "Eaton Cooper Power series parking stand, 25 kV, 200A loadbreak bushing, MCOV: 15.3 kV, Duty cycle: 18 kV, #4 AWG copper lead, Ground lead: 36 inch",
                "specificationLabel": "Especificaciones",
                "resourceLabel": "Recursos",
                "familyName": "Eaton Cooper Power series parking stand",
                "compareLabel": "Compare",
                "marketingDescription": "Eaton’s Cooper Power series elbow arresters provide shielded deadfront arrester protection with metal oxide varistor elbow and parking stand arresters used in pad-mounted, transformer and entry cabinets, vaults, switching enclosures and other installations",
                "serialFlag": false,
                "serialAuthFlag": false,
                "replacements": [],
                "crossSell": [],
                "upSell": [],
                "images": [],
                "resources": [],
                "status": "Active",
                "label": "3237758C18M",
                "forPriceSpider": false,
                "forPowerReviews": false,
                "doNotShowProductImages": false
            },
            {
                "attributeGroups": [
                    {
                        "attributeList": []
                    }
                ],
                "attributeTables": [],
                "skuPageUrl": "https://www.eaton.com/mx/es-mx/skuPage.3238018C10M.html",
                "skuPageSpecificationUrl": "https://www.eaton.com/mx/es-mx/skuPage.3238018C10M.html#tab-1",
                "skuPageResourcesUrl": "https://www.eaton.com/mx/es-mx/skuPage.3238018C10M.html#tab-2",
                "desktopRendition": "https://www.eaton.com/mdmfiles/PDM26807831/3238018C10M_C/110x110_96dpi",
                "mobileRendition": "https://www.eaton.com/mdmfiles/PDM26807831/3238018C10M_C/500x500_72dpi",
                "catalogNumber": "3238018C10M",
                "modelCode": "",
                "price": "",
                "longDescription": "Eaton Cooper Power series elbow, 15 kV, 200A loadbreak, MCOV: 8.4 kV, Duty cycle: 10 kV, Ground lead: 36 inch, #4 AWG copper lead",
                "specificationLabel": "Especificaciones",
                "resourceLabel": "Recursos",
                "familyName": "Eaton Cooper Power series elbow",
                "compareLabel": "Compare",
                "marketingDescription": "Eaton’s Cooper Power series elbow arresters provide shielded deadfront arrester protection with metal oxide varistor elbow and parking stand arresters used in pad-mounted, transformer and entry cabinets, vaults, switching enclosures and other installations",
                "serialFlag": false,
                "serialAuthFlag": false,
                "replacements": [],
                "crossSell": [],
                "upSell": [],
                "images": [],
                "resources": [],
                "status": "Active",
                "label": "3238018C10M",
                "forPriceSpider": false,
                "forPowerReviews": false,
                "doNotShowProductImages": false
            },
            {
                "attributeGroups": [
                    {
                        "attributeList": []
                    }
                ],
                "attributeTables": [],
                "skuPageUrl": "https://www.eaton.com/mx/es-mx/skuPage.3238018C12M.html",
                "skuPageSpecificationUrl": "https://www.eaton.com/mx/es-mx/skuPage.3238018C12M.html#tab-1",
                "skuPageResourcesUrl": "https://www.eaton.com/mx/es-mx/skuPage.3238018C12M.html#tab-2",
                "desktopRendition": "https://www.eaton.com/mdmfiles/PDM26807831/3238018C10M_C/110x110_96dpi",
                "mobileRendition": "https://www.eaton.com/mdmfiles/PDM26807831/3238018C10M_C/500x500_72dpi",
                "catalogNumber": "3238018C12M",
                "modelCode": "",
                "price": "",
                "longDescription": "Eaton Cooper Power series elbow, 15 kV, 200A loadbreak, MCOV: 10.2 kV, Duty cycle: 12 kV, #4 AWG copper lead, Ground lead: 36 inch",
                "specificationLabel": "Especificaciones",
                "resourceLabel": "Recursos",
                "familyName": "Eaton Cooper Power series elbow",
                "compareLabel": "Compare",
                "marketingDescription": "Eaton’s Cooper Power series elbow arresters provide shielded deadfront arrester protection with metal oxide varistor elbow and parking stand arresters used in pad-mounted, transformer and entry cabinets, vaults, switching enclosures and other installations",
                "serialFlag": false,
                "serialAuthFlag": false,
                "replacements": [],
                "crossSell": [],
                "upSell": [],
                "images": [],
                "resources": [],
                "status": "Active",
                "label": "3238018C12M",
                "forPriceSpider": false,
                "forPowerReviews": false,
                "doNotShowProductImages": false
            },
            {
                "attributeGroups": [
                    {
                        "attributeList": []
                    }
                ],
                "attributeTables": [],
                "skuPageUrl": "https://www.eaton.com/mx/es-mx/skuPage.3238019C10M.html",
                "skuPageSpecificationUrl": "https://www.eaton.com/mx/es-mx/skuPage.3238019C10M.html#tab-1",
                "skuPageResourcesUrl": "https://www.eaton.com/mx/es-mx/skuPage.3238019C10M.html#tab-2",
                "desktopRendition": "https://www.eaton.com/mdmfiles/PDM26807834/3238019C18M_C/110x110_96dpi",
                "mobileRendition": "https://www.eaton.com/mdmfiles/PDM26807834/3238019C18M_C/500x500_72dpi",
                "catalogNumber": "3238019C10M",
                "modelCode": "",
                "price": "",
                "longDescription": "Eaton Cooper Power series elbow, 25 kV, 200A loadbreak, MCOV: 8.4 kV, Duty cycle: 10 kV, 50-60 Hz, #4 AWG copper lead, Ground lead: 36 inch",
                "specificationLabel": "Especificaciones",
                "resourceLabel": "Recursos",
                "familyName": "Eaton Cooper Power series elbow",
                "compareLabel": "Compare",
                "marketingDescription": "Eaton’s Cooper Power series elbow arresters provide shielded deadfront arrester protection with metal oxide varistor elbow and parking stand arresters used in pad-mounted, transformer and entry cabinets, vaults, switching enclosures and other installations",
                "serialFlag": false,
                "serialAuthFlag": false,
                "replacements": [],
                "crossSell": [],
                "upSell": [],
                "images": [],
                "resources": [],
                "status": "Active",
                "label": "3238019C10M",
                "forPriceSpider": false,
                "forPowerReviews": false,
                "doNotShowProductImages": false
            },
            {
                "attributeGroups": [
                    {
                        "attributeList": []
                    }
                ],
                "attributeTables": [],
                "skuPageUrl": "https://www.eaton.com/mx/es-mx/skuPage.3238019C18M.html",
                "skuPageSpecificationUrl": "https://www.eaton.com/mx/es-mx/skuPage.3238019C18M.html#tab-1",
                "skuPageResourcesUrl": "https://www.eaton.com/mx/es-mx/skuPage.3238019C18M.html#tab-2",
                "desktopRendition": "https://www.eaton.com/mdmfiles/PDM26807834/3238019C18M_C/110x110_96dpi",
                "mobileRendition": "https://www.eaton.com/mdmfiles/PDM26807834/3238019C18M_C/500x500_72dpi",
                "catalogNumber": "3238019C18M",
                "modelCode": "",
                "price": "",
                "longDescription": "Eaton Cooper Power series elbow, 25 kV, 200A loadbreak, MCOV: 15.3 kV, Duty cycle: 18 kV, 50-60 Hz, #4 AWG copper lead, Ground lead: 36 inch",
                "specificationLabel": "Especificaciones",
                "resourceLabel": "Recursos",
                "familyName": "Eaton Cooper Power series elbow",
                "compareLabel": "Compare",
                "marketingDescription": "Eaton’s Cooper Power series elbow arresters provide shielded deadfront arrester protection with metal oxide varistor elbow and parking stand arresters used in pad-mounted, transformer and entry cabinets, vaults, switching enclosures and other installations",
                "serialFlag": false,
                "serialAuthFlag": false,
                "replacements": [],
                "crossSell": [],
                "upSell": [],
                "images": [],
                "resources": [],
                "status": "Active",
                "label": "3238019C18M",
                "forPriceSpider": false,
                "forPowerReviews": false,
                "doNotShowProductImages": false
            },
            {
                "attributeGroups": [
                    {
                        "attributeList": []
                    }
                ],
                "attributeTables": [],
                "skuPageUrl": "https://www.eaton.com/mx/es-mx/skuPage.3238020C27M.html",
                "skuPageSpecificationUrl": "https://www.eaton.com/mx/es-mx/skuPage.3238020C27M.html#tab-1",
                "skuPageResourcesUrl": "https://www.eaton.com/mx/es-mx/skuPage.3238020C27M.html#tab-2",
                "desktopRendition": "https://www.eaton.com/mdmfiles/PDM30074984/3238020C27M_C/110x110_96dpi",
                "mobileRendition": "https://www.eaton.com/mdmfiles/PDM30074984/3238020C27M_C/500x500_72dpi",
                "catalogNumber": "3238020C27M",
                "modelCode": "",
                "price": "",
                "longDescription": "Eaton Cooper Power series elbow, 35 kV, 200A loadbreak, MCOV: 22 kV, Duty cycle: 27 kV, 50-60 Hz, #4 AWG copper lead, Ground lead: 36 inch",
                "specificationLabel": "Especificaciones",
                "resourceLabel": "Recursos",
                "familyName": "Eaton Cooper Power series elbow",
                "compareLabel": "Compare",
                "marketingDescription": "Eaton’s Cooper Power series elbow arresters provide shielded deadfront arrester protection with metal oxide varistor elbow and parking stand arresters used in pad-mounted, transformer and entry cabinets, vaults, switching enclosures and other installations",
                "serialFlag": false,
                "serialAuthFlag": false,
                "replacements": [],
                "crossSell": [],
                "upSell": [],
                "images": [],
                "resources": [],
                "status": "Active",
                "label": "3238020C27M",
                "forPriceSpider": false,
                "forPowerReviews": false,
                "doNotShowProductImages": false
            }
        ]
    },
    {
        "url": "https://www.eaton.com/mx/es-mx/catalog/medium-voltage-power-distribution-control-systems/junctions.html",
        "target": "_self",
        "goToProductLabel": "Ir a Uniones",
        "desktopRendition": "https://www.eaton.com/mdmfiles/PDM31015079/LJ215C4U_C/500x500_72dpi",
        "mobileRendition": "https://www.eaton.com/mdmfiles/PDM31015079/LJ215C4U_C/500x500_72dpi",
        "discontinued": false,
        "discontinuedLabel": "Descontinuado",
        "tobediscontinued": false,
        "tobediscontinuedLabel": "Será descontinuado",
        "newBadgeVisible": false,
        "newBadgeLabel": "Nuevo",
        "showSubCategory": false,
        "subCategoryName": "",
        "showProductDescription": true,
        "productGridDescription": "",
        "productName": "Uniones",
        "desc": "Las barras de uniones de la serie Cooper Power de Eaton están diseñadas para aplicaciones en cajas de empalme o aparatos y se pueden utilizar para bucles, cambios de toma y seccionamiento. ",
        "models": [
            {
                "attributeGroups": [
                    {
                        "attributeList": []
                    }
                ],
                "attributeTables": [],
                "skuPageUrl": "https://www.eaton.com/mx/es-mx/skuPage.LJ215C2B.html",
                "skuPageSpecificationUrl": "https://www.eaton.com/mx/es-mx/skuPage.LJ215C2B.html#tab-1",
                "skuPageResourcesUrl": "https://www.eaton.com/mx/es-mx/skuPage.LJ215C2B.html#tab-2",
                "desktopRendition": "https://www.eaton.com/mdmfiles/PDM31015060/LJ215C2B_C/110x110_96dpi",
                "mobileRendition": "https://www.eaton.com/mdmfiles/PDM31015060/LJ215C2B_C/500x500_72dpi",
                "catalogNumber": "LJ215C2B",
                "modelCode": "",
                "price": "",
                "longDescription": "Eaton Cooper Power series loadbreak junction, Loadbreak, EPDM rubber external/insulation, copper internal current-carrying parts, SS bracket, 15 kV, BIL: 95 kV, 200 A, Positions: 2",
                "specificationLabel": "Especificaciones",
                "resourceLabel": "Recursos",
                "familyName": "Eaton Cooper Power series loadbreak junction",
                "compareLabel": "Compare",
                "marketingDescription": "Eaton’s Cooper Power series junction bars are designed for vault or apparatus applications and can be used for looping, tapping and sectionalizing",
                "serialFlag": false,
                "serialAuthFlag": false,
                "replacements": [],
                "crossSell": [],
                "upSell": [],
                "images": [],
                "resources": [],
                "status": "Active",
                "label": "LJ215C2B",
                "forPriceSpider": false,
                "forPowerReviews": false,
                "doNotShowProductImages": false
            },
            {
                "attributeGroups": [
                    {
                        "attributeList": []
                    }
                ],
                "attributeTables": [],
                "skuPageUrl": "https://www.eaton.com/mx/es-mx/skuPage.LJ215C3B.html",
                "skuPageSpecificationUrl": "https://www.eaton.com/mx/es-mx/skuPage.LJ215C3B.html#tab-1",
                "skuPageResourcesUrl": "https://www.eaton.com/mx/es-mx/skuPage.LJ215C3B.html#tab-2",
                "desktopRendition": "https://www.eaton.com/mdmfiles/PDM31015069/LJ215C3B_C/110x110_96dpi",
                "mobileRendition": "https://www.eaton.com/mdmfiles/PDM31015069/LJ215C3B_C/500x500_72dpi",
                "catalogNumber": "LJ215C3B",
                "modelCode": "",
                "price": "",
                "longDescription": "Eaton Cooper Power series loadbreak junction, Loadbreak, EPDM rubber external/insulation, copper internal current-carrying parts, SS bracket, 15 kV, BIL: 95 kV, 200 A, Positions: 3",
                "specificationLabel": "Especificaciones",
                "resourceLabel": "Recursos",
                "familyName": "Eaton Cooper Power series loadbreak junction",
                "compareLabel": "Compare",
                "marketingDescription": "Eaton’s Cooper Power series junction bars are designed for vault or apparatus applications and can be used for looping, tapping and sectionalizing",
                "serialFlag": false,
                "serialAuthFlag": false,
                "replacements": [],
                "crossSell": [],
                "upSell": [],
                "images": [],
                "resources": [],
                "status": "Active",
                "label": "LJ215C3B",
                "forPriceSpider": false,
                "forPowerReviews": false,
                "doNotShowProductImages": false
            },
            {
                "attributeGroups": [
                    {
                        "attributeList": []
                    }
                ],
                "attributeTables": [],
                "skuPageUrl": "https://www.eaton.com/mx/es-mx/skuPage.LJ215C4B.html",
                "skuPageSpecificationUrl": "https://www.eaton.com/mx/es-mx/skuPage.LJ215C4B.html#tab-1",
                "skuPageResourcesUrl": "https://www.eaton.com/mx/es-mx/skuPage.LJ215C4B.html#tab-2",
                "desktopRendition": "https://www.eaton.com/mdmfiles/PDM31015074/LJ215C4B_C/110x110_96dpi",
                "mobileRendition": "https://www.eaton.com/mdmfiles/PDM31015074/LJ215C4B_C/500x500_72dpi",
                "catalogNumber": "LJ215C4B",
                "modelCode": "",
                "price": "",
                "longDescription": "Eaton Cooper Power series loadbreak junction, Loadbreak, EPDM rubber external/insulation, copper internal current-carrying parts, SS bracket, BIL: 95 kV, 15 kV, 200 A, Positions: 4",
                "specificationLabel": "Especificaciones",
                "resourceLabel": "Recursos",
                "familyName": "Eaton Cooper Power series loadbreak junction",
                "compareLabel": "Compare",
                "marketingDescription": "Eaton’s Cooper Power series junction bars are designed for vault or apparatus applications and can be used for looping, tapping and sectionalizing",
                "serialFlag": false,
                "serialAuthFlag": false,
                "replacements": [],
                "crossSell": [],
                "upSell": [],
                "images": [],
                "resources": [],
                "status": "Active",
                "label": "LJ215C4B",
                "forPriceSpider": false,
                "forPowerReviews": false,
                "doNotShowProductImages": false
            },
            {
                "attributeGroups": [
                    {
                        "attributeList": []
                    }
                ],
                "attributeTables": [],
                "skuPageUrl": "https://www.eaton.com/mx/es-mx/skuPage.LJ225C2B.html",
                "skuPageSpecificationUrl": "https://www.eaton.com/mx/es-mx/skuPage.LJ225C2B.html#tab-1",
                "skuPageResourcesUrl": "https://www.eaton.com/mx/es-mx/skuPage.LJ225C2B.html#tab-2",
                "desktopRendition": "https://www.eaton.com/mdmfiles/PDM31015083/LJ225C2B_C/110x110_96dpi",
                "mobileRendition": "https://www.eaton.com/mdmfiles/PDM31015083/LJ225C2B_C/500x500_72dpi",
                "catalogNumber": "LJ225C2B",
                "modelCode": "",
                "price": "",
                "longDescription": "Eaton Cooper Power series loadbreak junction, Loadbreak, EPDM rubber external/insulation, copper internal current-carrying parts, SS bracket, 25 kV, BIL: 125 kV, 200 A, Positions: 2",
                "specificationLabel": "Especificaciones",
                "resourceLabel": "Recursos",
                "familyName": "Eaton Cooper Power series loadbreak junction",
                "compareLabel": "Compare",
                "marketingDescription": "Eaton’s Cooper Power series junction bars are designed for vault or apparatus applications and can be used for looping, tapping and sectionalizing",
                "serialFlag": false,
                "serialAuthFlag": false,
                "replacements": [],
                "crossSell": [],
                "upSell": [],
                "images": [],
                "resources": [],
                "status": "Active",
                "label": "LJ225C2B",
                "forPriceSpider": false,
                "forPowerReviews": false,
                "doNotShowProductImages": false
            },
            {
                "attributeGroups": [
                    {
                        "attributeList": []
                    }
                ],
                "attributeTables": [],
                "skuPageUrl": "https://www.eaton.com/mx/es-mx/skuPage.LJ225C3B.html",
                "skuPageSpecificationUrl": "https://www.eaton.com/mx/es-mx/skuPage.LJ225C3B.html#tab-1",
                "skuPageResourcesUrl": "https://www.eaton.com/mx/es-mx/skuPage.LJ225C3B.html#tab-2",
                "desktopRendition": "https://www.eaton.com/mdmfiles/PDM31015092/LJ225C3B_C/110x110_96dpi",
                "mobileRendition": "https://www.eaton.com/mdmfiles/PDM31015092/LJ225C3B_C/500x500_72dpi",
                "catalogNumber": "LJ225C3B",
                "modelCode": "",
                "price": "",
                "longDescription": "Eaton Cooper Power series loadbreak junction, Loadbreak, EPDM rubber external/insulation, copper internal current-carrying parts, SS bracket, 25 kV, BIL: 125 kV, 200 A, Positions: 3",
                "specificationLabel": "Especificaciones",
                "resourceLabel": "Recursos",
                "familyName": "Eaton Cooper Power series loadbreak junction",
                "compareLabel": "Compare",
                "marketingDescription": "Eaton’s Cooper Power series junction bars are designed for vault or apparatus applications and can be used for looping, tapping and sectionalizing",
                "serialFlag": false,
                "serialAuthFlag": false,
                "replacements": [],
                "crossSell": [],
                "upSell": [],
                "images": [],
                "resources": [],
                "status": "Active",
                "label": "LJ225C3B",
                "forPriceSpider": false,
                "forPowerReviews": false,
                "doNotShowProductImages": false
            },
            {
                "attributeGroups": [
                    {
                        "attributeList": []
                    }
                ],
                "attributeTables": [],
                "skuPageUrl": "https://www.eaton.com/mx/es-mx/skuPage.LJ225C4B.html",
                "skuPageSpecificationUrl": "https://www.eaton.com/mx/es-mx/skuPage.LJ225C4B.html#tab-1",
                "skuPageResourcesUrl": "https://www.eaton.com/mx/es-mx/skuPage.LJ225C4B.html#tab-2",
                "desktopRendition": "https://www.eaton.com/mdmfiles/PDM31015101/LJ225C4B_C/110x110_96dpi",
                "mobileRendition": "https://www.eaton.com/mdmfiles/PDM31015101/LJ225C4B_C/500x500_72dpi",
                "catalogNumber": "LJ225C4B",
                "modelCode": "",
                "price": "",
                "longDescription": "Eaton Cooper Power series loadbreak junction, Loadbreak, EPDM rubber external/insulation, copper internal current-carrying parts, SS bracket, 25 kV, BIL: 125 kV, 200 A, Positions: 4",
                "specificationLabel": "Especificaciones",
                "resourceLabel": "Recursos",
                "familyName": "Eaton Cooper Power series loadbreak junction",
                "compareLabel": "Compare",
                "marketingDescription": "Eaton’s Cooper Power series junction bars are designed for vault or apparatus applications and can be used for looping, tapping and sectionalizing",
                "serialFlag": false,
                "serialAuthFlag": false,
                "replacements": [],
                "crossSell": [],
                "upSell": [],
                "images": [],
                "resources": [],
                "status": "Active",
                "label": "LJ225C4B",
                "forPriceSpider": false,
                "forPowerReviews": false,
                "doNotShowProductImages": false
            },
            {
                "attributeGroups": [
                    {
                        "attributeList": []
                    }
                ],
                "attributeTables": [],
                "skuPageUrl": "https://www.eaton.com/mx/es-mx/skuPage.LJ235C3B.html",
                "skuPageSpecificationUrl": "https://www.eaton.com/mx/es-mx/skuPage.LJ235C3B.html#tab-1",
                "skuPageResourcesUrl": "https://www.eaton.com/mx/es-mx/skuPage.LJ235C3B.html#tab-2",
                "desktopRendition": "https://www.eaton.com/mdmfiles/PDM31015110/LJ235C3B_C/110x110_96dpi",
                "mobileRendition": "https://www.eaton.com/mdmfiles/PDM31015110/LJ235C3B_C/500x500_72dpi",
                "catalogNumber": "LJ235C3B",
                "modelCode": "",
                "price": "",
                "longDescription": "Eaton Cooper Power series loadbreak junction, Loadbreak, EPDM rubber external/insulation, copper internal current-carrying parts, SS bracket, 35 kV, BIL: 150 kV, 200 A, Positions: 3",
                "specificationLabel": "Especificaciones",
                "resourceLabel": "Recursos",
                "familyName": "Eaton Cooper Power series loadbreak junction",
                "compareLabel": "Compare",
                "marketingDescription": "Eaton’s Cooper Power series junction bars are designed for vault or apparatus applications and can be used for looping, tapping and sectionalizing",
                "serialFlag": false,
                "serialAuthFlag": false,
                "replacements": [],
                "crossSell": [],
                "upSell": [],
                "images": [],
                "resources": [],
                "status": "Active",
                "label": "LJ235C3B",
                "forPriceSpider": false,
                "forPowerReviews": false,
                "doNotShowProductImages": false
            },
            {
                "attributeGroups": [
                    {
                        "attributeList": []
                    }
                ],
                "attributeTables": [],
                "skuPageUrl": "https://www.eaton.com/mx/es-mx/skuPage.LJ235C4B.html",
                "skuPageSpecificationUrl": "https://www.eaton.com/mx/es-mx/skuPage.LJ235C4B.html#tab-1",
                "skuPageResourcesUrl": "https://www.eaton.com/mx/es-mx/skuPage.LJ235C4B.html#tab-2",
                "desktopRendition": "https://www.eaton.com/mdmfiles/PDM31015114/LJ235C4B_C/110x110_96dpi",
                "mobileRendition": "https://www.eaton.com/mdmfiles/PDM31015114/LJ235C4B_C/500x500_72dpi",
                "catalogNumber": "LJ235C4B",
                "modelCode": "",
                "price": "",
                "longDescription": "Eaton Cooper Power series loadbreak junction, Loadbreak, EPDM rubber external/insulation, copper internal current-carrying parts, SS bracket, 35 kV, BIL: 150 kV, 200 A, Positions: 4",
                "specificationLabel": "Especificaciones",
                "resourceLabel": "Recursos",
                "familyName": "Eaton Cooper Power series loadbreak junction",
                "compareLabel": "Compare",
                "marketingDescription": "Eaton’s Cooper Power series junction bars are designed for vault or apparatus applications and can be used for looping, tapping and sectionalizing",
                "serialFlag": false,
                "serialAuthFlag": false,
                "replacements": [],
                "crossSell": [],
                "upSell": [],
                "images": [],
                "resources": [],
                "status": "Active",
                "label": "LJ235C4B",
                "forPriceSpider": false,
                "forPowerReviews": false,
                "doNotShowProductImages": false
            }
        ]
    }
]